/**
 * Generated by orval v7.11.2 🍺
 * Do not edit manually.
 * UIBFS Membership Service API
 * Membership programmes, applications, and category management endpoints.
 * OpenAPI spec version: 1.0.0
 */
import { useMutation, useQuery } from "@tanstack/react-query";
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import * as axios from "axios";
import type { AxiosError, AxiosRequestConfig, AxiosResponse } from "axios";

import type {
  ActivitySummaryDTO,
  ApiResponse,
  ApplicationCorrectionRequestDTO,
  ApplicationCreateDTO,
  ApplicationResponseDTO,
  ApplicationUpdateDTO,
  AttendanceMarkDTO,
  ByMemberParams,
  CPDEventCreateDTO,
  CPDEventResponseDTO,
  CPDEventUpdateDTO,
  CPDPointsAwardBulkUploadRequest,
  CPDPointsAwardCreateDTO,
  CPDPointsAwardResponseDTO,
  CancelRegistration200,
  CancelRegistration400,
  CancelRegistration403,
  CancelRegistration404,
  CancelRegistration500,
  ChangeApplicationStatusParams,
  ChangeEventStatusParams,
  CommunityCreateDTO,
  CommunityDTO,
  CommunityEventCreateDTO,
  CommunityEventDTO,
  CommunityEventUpdateDTO,
  CommunityUpdateDTO,
  CompleteCourse200,
  CreateInvite200,
  CreateMembershipBenefitDTO,
  DemographicsSlice,
  DiscourseInviteRequest,
  DownloadDocument200,
  EnrollCourse200,
  ErrorResponse,
  ExportReport200,
  FinanceParams,
  FinancialReport,
  GenerateBulkData200,
  GetActiveApprovedApplicationsParams,
  GetActivityTrends200,
  GetActivityTrendsParams,
  GetAllEventsParams,
  GetApplicationsByStatusParams,
  GetApplicationsParams,
  GetApprovedApplicationsParams,
  GetApprovedApplicationsWithDetailsParams,
  GetAwardsByEventParams,
  GetAwardsByMemberParams,
  GetEngagementScore200,
  GetEngagementScore401,
  GetEngagementScoreParams,
  GetEventParticipantsParams,
  GetEventsByStatusParams,
  GetMemberSummaryParams,
  GetMyApplicationsParams,
  GetMyRegistrationsParams,
  GetPastEventsParams,
  GetRecentActivityParams,
  GetRenewalRequestsParams,
  GetTotalActivityCount200,
  GetTrainingNeedsParams,
  GetUpcomingEventsParams,
  InternalNotification,
  InternalNotificationFeedResponse,
  InternalNotificationTestSyncResponse,
  JoinCommunity200,
  LeaveCommunity200,
  ListAllPastResourceParams,
  ListBirthdaysParams,
  ListCommunitiesParams,
  ListMyCommunitiesParams,
  ListRenewalsParams,
  MembershipBenefitResponseDTO,
  MembershipCategoryRequest,
  MembershipCategoryResponse,
  MembershipRenewalApplicationDTO,
  MembershipRenewalCreateDTO,
  MyCPDPointsResponseDTO,
  PageApplicationResponseDTO,
  PageCommunityDTO,
  PageMembershipRenewalResponseDTO,
  PageResourceAccessEvent,
  PageTrainingNeedResponseDTO,
  PaginatedResponseCPDPointsAwardResponseDTO,
  PastCpdResourceCreate,
  PastCpdResourceUpdate,
  Ping200,
  PlayVideo200,
  ProblemDetail,
  ProgramDTO,
  ProgramRequestDTO,
  RegisterForEventParams,
  RegistrationStats,
  RegistrationsParams,
  RequirementDto,
  ResourceAccessEvent,
  RestPageCPDEvent,
  RestPageCPDParticipant,
  RestPageCPDPointsAward,
  RestPageImpl,
  RestPagePastCpdResource,
  SearchEventsParams,
  SearchOrListParams,
  ShareResource200,
  SuccessResponse,
  TopResources200Item,
  TopResourcesParams,
  TrainingNeedBulkCreateDTO,
  TrainingNeedResponseDTO,
  TrainingNeedSubmitDTO,
  TrainingNeedUpdateDTO,
  TrainingNeedsReport,
  ViewDocument200,
  ViewPage1Params,
  ViewPage200,
} from "./models";

/**
 * Replaces the properties of an existing programme.
 * @summary Update programme
 */
export const updateCPDProgram = (
  id: number,
  programRequestDTO: ProgramRequestDTO,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<ProgramDTO>> => {
  return axios.default.put(
    `https://membership.uibfs.or.ug/uib-api/membership/update-cpd-program/${id}`,
    programRequestDTO,
    options,
  );
};

export const getUpdateCPDProgramMutationOptions = <
  TError = AxiosError<ProgramDTO>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateCPDProgram>>,
    TError,
    { id: number; data: ProgramRequestDTO },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateCPDProgram>>,
  TError,
  { id: number; data: ProgramRequestDTO },
  TContext
> => {
  const mutationKey = ["updateCPDProgram"];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateCPDProgram>>,
    { id: number; data: ProgramRequestDTO }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateCPDProgram(id, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateCPDProgramMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateCPDProgram>>
>;
export type UpdateCPDProgramMutationBody = ProgramRequestDTO;
export type UpdateCPDProgramMutationError = AxiosError<ProgramDTO>;

/**
 * @summary Update programme
 */
export const useUpdateCPDProgram = <
  TError = AxiosError<ProgramDTO>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateCPDProgram>>,
      TError,
      { id: number; data: ProgramRequestDTO },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof updateCPDProgram>>,
  TError,
  { id: number; data: ProgramRequestDTO },
  TContext
> => {
  const mutationOptions = getUpdateCPDProgramMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

export const getTrainingNeed = (
  id: number,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<TrainingNeedResponseDTO>> => {
  return axios.default.get(
    `https://membership.uibfs.or.ug/uib-api/membership/training-needs/${id}`,
    options,
  );
};

export const getGetTrainingNeedQueryKey = (id?: number) => {
  return [
    `https://membership.uibfs.or.ug/uib-api/membership/training-needs/${id}`,
  ] as const;
};

export const getGetTrainingNeedQueryOptions = <
  TData = Awaited<ReturnType<typeof getTrainingNeed>>,
  TError = AxiosError<unknown>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTrainingNeed>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetTrainingNeedQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getTrainingNeed>>> = ({
    signal,
  }) => getTrainingNeed(id, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getTrainingNeed>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetTrainingNeedQueryResult = NonNullable<
  Awaited<ReturnType<typeof getTrainingNeed>>
>;
export type GetTrainingNeedQueryError = AxiosError<unknown>;

export function useGetTrainingNeed<
  TData = Awaited<ReturnType<typeof getTrainingNeed>>,
  TError = AxiosError<unknown>,
>(
  id: number,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTrainingNeed>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTrainingNeed>>,
          TError,
          Awaited<ReturnType<typeof getTrainingNeed>>
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetTrainingNeed<
  TData = Awaited<ReturnType<typeof getTrainingNeed>>,
  TError = AxiosError<unknown>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTrainingNeed>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTrainingNeed>>,
          TError,
          Awaited<ReturnType<typeof getTrainingNeed>>
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetTrainingNeed<
  TData = Awaited<ReturnType<typeof getTrainingNeed>>,
  TError = AxiosError<unknown>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTrainingNeed>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetTrainingNeed<
  TData = Awaited<ReturnType<typeof getTrainingNeed>>,
  TError = AxiosError<unknown>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTrainingNeed>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetTrainingNeedQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const updateTrainingNeed = (
  id: number,
  trainingNeedUpdateDTO: TrainingNeedUpdateDTO,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<TrainingNeedResponseDTO>> => {
  return axios.default.put(
    `https://membership.uibfs.or.ug/uib-api/membership/training-needs/${id}`,
    trainingNeedUpdateDTO,
    options,
  );
};

export const getUpdateTrainingNeedMutationOptions = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateTrainingNeed>>,
    TError,
    { id: number; data: TrainingNeedUpdateDTO },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateTrainingNeed>>,
  TError,
  { id: number; data: TrainingNeedUpdateDTO },
  TContext
> => {
  const mutationKey = ["updateTrainingNeed"];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateTrainingNeed>>,
    { id: number; data: TrainingNeedUpdateDTO }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateTrainingNeed(id, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateTrainingNeedMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateTrainingNeed>>
>;
export type UpdateTrainingNeedMutationBody = TrainingNeedUpdateDTO;
export type UpdateTrainingNeedMutationError = AxiosError<unknown>;

export const useUpdateTrainingNeed = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateTrainingNeed>>,
      TError,
      { id: number; data: TrainingNeedUpdateDTO },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof updateTrainingNeed>>,
  TError,
  { id: number; data: TrainingNeedUpdateDTO },
  TContext
> => {
  const mutationOptions = getUpdateTrainingNeedMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

export const deleteTrainingNeed = (
  id: number,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<null>> => {
  return axios.default.delete(
    `https://membership.uibfs.or.ug/uib-api/membership/training-needs/${id}`,
    options,
  );
};

export const getDeleteTrainingNeedMutationOptions = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteTrainingNeed>>,
    TError,
    { id: number },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteTrainingNeed>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ["deleteTrainingNeed"];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteTrainingNeed>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return deleteTrainingNeed(id, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteTrainingNeedMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteTrainingNeed>>
>;

export type DeleteTrainingNeedMutationError = AxiosError<unknown>;

export const useDeleteTrainingNeed = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteTrainingNeed>>,
      TError,
      { id: number },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof deleteTrainingNeed>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationOptions = getDeleteTrainingNeedMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Updates label, type or validation configuration for a requirement.
 * @summary Update requirement
 */
export const updateRequirement = (
  id: number,
  requirementDto: RequirementDto,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<ApiResponse>> => {
  return axios.default.put(
    `https://membership.uibfs.or.ug/uib-api/membership/requirements/${id}`,
    requirementDto,
    options,
  );
};

export const getUpdateRequirementMutationOptions = <
  TError = AxiosError<ApiResponse | ApiResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateRequirement>>,
    TError,
    { id: number; data: RequirementDto },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateRequirement>>,
  TError,
  { id: number; data: RequirementDto },
  TContext
> => {
  const mutationKey = ["updateRequirement"];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateRequirement>>,
    { id: number; data: RequirementDto }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateRequirement(id, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateRequirementMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateRequirement>>
>;
export type UpdateRequirementMutationBody = RequirementDto;
export type UpdateRequirementMutationError = AxiosError<
  ApiResponse | ApiResponse
>;

/**
 * @summary Update requirement
 */
export const useUpdateRequirement = <
  TError = AxiosError<ApiResponse | ApiResponse>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateRequirement>>,
      TError,
      { id: number; data: RequirementDto },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof updateRequirement>>,
  TError,
  { id: number; data: RequirementDto },
  TContext
> => {
  const mutationOptions = getUpdateRequirementMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Removes a requirement permanently using its identifier.
 * @summary Delete requirement
 */
export const deleteRequirement = (
  id: number,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<ApiResponse>> => {
  return axios.default.delete(
    `https://membership.uibfs.or.ug/uib-api/membership/requirements/${id}`,
    options,
  );
};

export const getDeleteRequirementMutationOptions = <
  TError = AxiosError<ApiResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteRequirement>>,
    TError,
    { id: number },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteRequirement>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ["deleteRequirement"];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteRequirement>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return deleteRequirement(id, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteRequirementMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteRequirement>>
>;

export type DeleteRequirementMutationError = AxiosError<ApiResponse>;

/**
 * @summary Delete requirement
 */
export const useDeleteRequirement = <
  TError = AxiosError<ApiResponse>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteRequirement>>,
      TError,
      { id: number },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof deleteRequirement>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationOptions = getDeleteRequirementMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Update the metadata and linkage details for an existing past CPD resource.
 * @summary Update a past CPD resource
 */
export const updatePastResource = (
  resourceId: number,
  pastCpdResourceUpdate: PastCpdResourceUpdate,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<ApiResponse>> => {
  return axios.default.put(
    `https://membership.uibfs.or.ug/uib-api/membership/cpd/past-resources/${resourceId}`,
    pastCpdResourceUpdate,
    options,
  );
};

export const getUpdatePastResourceMutationOptions = <
  TError = AxiosError<ApiResponse | ApiResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updatePastResource>>,
    TError,
    { resourceId: number; data: PastCpdResourceUpdate },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updatePastResource>>,
  TError,
  { resourceId: number; data: PastCpdResourceUpdate },
  TContext
> => {
  const mutationKey = ["updatePastResource"];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updatePastResource>>,
    { resourceId: number; data: PastCpdResourceUpdate }
  > = (props) => {
    const { resourceId, data } = props ?? {};

    return updatePastResource(resourceId, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdatePastResourceMutationResult = NonNullable<
  Awaited<ReturnType<typeof updatePastResource>>
>;
export type UpdatePastResourceMutationBody = PastCpdResourceUpdate;
export type UpdatePastResourceMutationError = AxiosError<
  ApiResponse | ApiResponse
>;

/**
 * @summary Update a past CPD resource
 */
export const useUpdatePastResource = <
  TError = AxiosError<ApiResponse | ApiResponse>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updatePastResource>>,
      TError,
      { resourceId: number; data: PastCpdResourceUpdate },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof updatePastResource>>,
  TError,
  { resourceId: number; data: PastCpdResourceUpdate },
  TContext
> => {
  const mutationOptions = getUpdatePastResourceMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Remove a past CPD resource by its identifier.
 * @summary Delete a past CPD resource
 */
export const deletePastResource = (
  resourceId: number,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<ApiResponse>> => {
  return axios.default.delete(
    `https://membership.uibfs.or.ug/uib-api/membership/cpd/past-resources/${resourceId}`,
    options,
  );
};

export const getDeletePastResourceMutationOptions = <
  TError = AxiosError<ApiResponse | ApiResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deletePastResource>>,
    TError,
    { resourceId: number },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deletePastResource>>,
  TError,
  { resourceId: number },
  TContext
> => {
  const mutationKey = ["deletePastResource"];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deletePastResource>>,
    { resourceId: number }
  > = (props) => {
    const { resourceId } = props ?? {};

    return deletePastResource(resourceId, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeletePastResourceMutationResult = NonNullable<
  Awaited<ReturnType<typeof deletePastResource>>
>;

export type DeletePastResourceMutationError = AxiosError<
  ApiResponse | ApiResponse
>;

/**
 * @summary Delete a past CPD resource
 */
export const useDeletePastResource = <
  TError = AxiosError<ApiResponse | ApiResponse>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deletePastResource>>,
      TError,
      { resourceId: number },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof deletePastResource>>,
  TError,
  { resourceId: number },
  TContext
> => {
  const mutationOptions = getDeletePastResourceMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Retrieve a specific CPD event by its ID
 * @summary Get CPD event by ID
 */
export const getEventById = (
  id: number,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<CPDEventResponseDTO>> => {
  return axios.default.get(
    `https://membership.uibfs.or.ug/uib-api/membership/cpd-events/${id}`,
    options,
  );
};

export const getGetEventByIdQueryKey = (id?: number) => {
  return [
    `https://membership.uibfs.or.ug/uib-api/membership/cpd-events/${id}`,
  ] as const;
};

export const getGetEventByIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getEventById>>,
  TError = AxiosError<ErrorResponse | ErrorResponse | ErrorResponse>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getEventById>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetEventByIdQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getEventById>>> = ({
    signal,
  }) => getEventById(id, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getEventById>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetEventByIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getEventById>>
>;
export type GetEventByIdQueryError = AxiosError<
  ErrorResponse | ErrorResponse | ErrorResponse
>;

export function useGetEventById<
  TData = Awaited<ReturnType<typeof getEventById>>,
  TError = AxiosError<ErrorResponse | ErrorResponse | ErrorResponse>,
>(
  id: number,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getEventById>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEventById>>,
          TError,
          Awaited<ReturnType<typeof getEventById>>
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetEventById<
  TData = Awaited<ReturnType<typeof getEventById>>,
  TError = AxiosError<ErrorResponse | ErrorResponse | ErrorResponse>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getEventById>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEventById>>,
          TError,
          Awaited<ReturnType<typeof getEventById>>
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetEventById<
  TData = Awaited<ReturnType<typeof getEventById>>,
  TError = AxiosError<ErrorResponse | ErrorResponse | ErrorResponse>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getEventById>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get CPD event by ID
 */

export function useGetEventById<
  TData = Awaited<ReturnType<typeof getEventById>>,
  TError = AxiosError<ErrorResponse | ErrorResponse | ErrorResponse>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getEventById>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetEventByIdQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Update an existing CPD event
 * @summary Update CPD event
 */
export const updateEvent = (
  id: number,
  cPDEventUpdateDTO: CPDEventUpdateDTO,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<CPDEventResponseDTO>> => {
  return axios.default.put(
    `https://membership.uibfs.or.ug/uib-api/membership/cpd-events/${id}`,
    cPDEventUpdateDTO,
    options,
  );
};

export const getUpdateEventMutationOptions = <
  TError = AxiosError<ErrorResponse | ErrorResponse | ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateEvent>>,
    TError,
    { id: number; data: CPDEventUpdateDTO },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateEvent>>,
  TError,
  { id: number; data: CPDEventUpdateDTO },
  TContext
> => {
  const mutationKey = ["updateEvent"];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateEvent>>,
    { id: number; data: CPDEventUpdateDTO }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateEvent(id, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateEventMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateEvent>>
>;
export type UpdateEventMutationBody = CPDEventUpdateDTO;
export type UpdateEventMutationError = AxiosError<
  ErrorResponse | ErrorResponse | ErrorResponse
>;

/**
 * @summary Update CPD event
 */
export const useUpdateEvent = <
  TError = AxiosError<ErrorResponse | ErrorResponse | ErrorResponse>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateEvent>>,
      TError,
      { id: number; data: CPDEventUpdateDTO },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof updateEvent>>,
  TError,
  { id: number; data: CPDEventUpdateDTO },
  TContext
> => {
  const mutationOptions = getUpdateEventMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Delete a CPD event by ID
 * @summary Delete CPD event
 */
export const deleteEvent = (
  id: number,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<SuccessResponse>> => {
  return axios.default.delete(
    `https://membership.uibfs.or.ug/uib-api/membership/cpd-events/${id}`,
    options,
  );
};

export const getDeleteEventMutationOptions = <
  TError = AxiosError<ErrorResponse | ErrorResponse | ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteEvent>>,
    TError,
    { id: number },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteEvent>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ["deleteEvent"];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteEvent>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return deleteEvent(id, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteEventMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteEvent>>
>;

export type DeleteEventMutationError = AxiosError<
  ErrorResponse | ErrorResponse | ErrorResponse
>;

/**
 * @summary Delete CPD event
 */
export const useDeleteEvent = <
  TError = AxiosError<ErrorResponse | ErrorResponse | ErrorResponse>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteEvent>>,
      TError,
      { id: number },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof deleteEvent>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationOptions = getDeleteEventMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Applies edits to a community when the caller owns or administers it.
 * @summary Update a community/chapter
 */
export const updateCommunity = (
  communityId: number,
  communityUpdateDTO: CommunityUpdateDTO,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<CommunityDTO>> => {
  return axios.default.put(
    `https://membership.uibfs.or.ug/uib-api/membership/communities/${communityId}`,
    communityUpdateDTO,
    options,
  );
};

export const getUpdateCommunityMutationOptions = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateCommunity>>,
    TError,
    { communityId: number; data: CommunityUpdateDTO },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateCommunity>>,
  TError,
  { communityId: number; data: CommunityUpdateDTO },
  TContext
> => {
  const mutationKey = ["updateCommunity"];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateCommunity>>,
    { communityId: number; data: CommunityUpdateDTO }
  > = (props) => {
    const { communityId, data } = props ?? {};

    return updateCommunity(communityId, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateCommunityMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateCommunity>>
>;
export type UpdateCommunityMutationBody = CommunityUpdateDTO;
export type UpdateCommunityMutationError = AxiosError<unknown>;

/**
 * @summary Update a community/chapter
 */
export const useUpdateCommunity = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateCommunity>>,
      TError,
      { communityId: number; data: CommunityUpdateDTO },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof updateCommunity>>,
  TError,
  { communityId: number; data: CommunityUpdateDTO },
  TContext
> => {
  const mutationOptions = getUpdateCommunityMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Modifies an existing event. Only members with proper permissions can call this.
 * @summary Update an event/meetup
 */
export const updateEvent1 = (
  eventId: number,
  communityEventUpdateDTO: CommunityEventUpdateDTO,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<CommunityEventDTO>> => {
  return axios.default.put(
    `https://membership.uibfs.or.ug/uib-api/membership/communities/events/${eventId}`,
    communityEventUpdateDTO,
    options,
  );
};

export const getUpdateEvent1MutationOptions = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateEvent1>>,
    TError,
    { eventId: number; data: CommunityEventUpdateDTO },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateEvent1>>,
  TError,
  { eventId: number; data: CommunityEventUpdateDTO },
  TContext
> => {
  const mutationKey = ["updateEvent1"];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateEvent1>>,
    { eventId: number; data: CommunityEventUpdateDTO }
  > = (props) => {
    const { eventId, data } = props ?? {};

    return updateEvent1(eventId, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateEvent1MutationResult = NonNullable<
  Awaited<ReturnType<typeof updateEvent1>>
>;
export type UpdateEvent1MutationBody = CommunityEventUpdateDTO;
export type UpdateEvent1MutationError = AxiosError<unknown>;

/**
 * @summary Update an event/meetup
 */
export const useUpdateEvent1 = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateEvent1>>,
      TError,
      { eventId: number; data: CommunityEventUpdateDTO },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof updateEvent1>>,
  TError,
  { eventId: number; data: CommunityEventUpdateDTO },
  TContext
> => {
  const mutationOptions = getUpdateEvent1MutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Deletes a community event. The caller must own the event or have admin rights.
 * @summary Delete an event/meetup
 */
export const deleteEvent1 = (
  eventId: number,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<ApiResponse>> => {
  return axios.default.delete(
    `https://membership.uibfs.or.ug/uib-api/membership/communities/events/${eventId}`,
    options,
  );
};

export const getDeleteEvent1MutationOptions = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteEvent1>>,
    TError,
    { eventId: number },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteEvent1>>,
  TError,
  { eventId: number },
  TContext
> => {
  const mutationKey = ["deleteEvent1"];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteEvent1>>,
    { eventId: number }
  > = (props) => {
    const { eventId } = props ?? {};

    return deleteEvent1(eventId, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteEvent1MutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteEvent1>>
>;

export type DeleteEvent1MutationError = AxiosError<unknown>;

/**
 * @summary Delete an event/meetup
 */
export const useDeleteEvent1 = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteEvent1>>,
      TError,
      { eventId: number },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof deleteEvent1>>,
  TError,
  { eventId: number },
  TContext
> => {
  const mutationOptions = getDeleteEvent1MutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

export const getCategoryById = (
  id: number,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<ApiResponse>> => {
  return axios.default.get(
    `https://membership.uibfs.or.ug/uib-api/membership/categories/${id}`,
    options,
  );
};

export const getGetCategoryByIdQueryKey = (id?: number) => {
  return [
    `https://membership.uibfs.or.ug/uib-api/membership/categories/${id}`,
  ] as const;
};

export const getGetCategoryByIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getCategoryById>>,
  TError = AxiosError<unknown>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCategoryById>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetCategoryByIdQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getCategoryById>>> = ({
    signal,
  }) => getCategoryById(id, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getCategoryById>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetCategoryByIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getCategoryById>>
>;
export type GetCategoryByIdQueryError = AxiosError<unknown>;

export function useGetCategoryById<
  TData = Awaited<ReturnType<typeof getCategoryById>>,
  TError = AxiosError<unknown>,
>(
  id: number,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCategoryById>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCategoryById>>,
          TError,
          Awaited<ReturnType<typeof getCategoryById>>
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetCategoryById<
  TData = Awaited<ReturnType<typeof getCategoryById>>,
  TError = AxiosError<unknown>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCategoryById>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCategoryById>>,
          TError,
          Awaited<ReturnType<typeof getCategoryById>>
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetCategoryById<
  TData = Awaited<ReturnType<typeof getCategoryById>>,
  TError = AxiosError<unknown>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCategoryById>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetCategoryById<
  TData = Awaited<ReturnType<typeof getCategoryById>>,
  TError = AxiosError<unknown>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCategoryById>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetCategoryByIdQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const updateCategory = (
  id: number,
  membershipCategoryRequest: MembershipCategoryRequest,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<ApiResponse>> => {
  return axios.default.put(
    `https://membership.uibfs.or.ug/uib-api/membership/categories/${id}`,
    membershipCategoryRequest,
    options,
  );
};

export const getUpdateCategoryMutationOptions = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateCategory>>,
    TError,
    { id: number; data: MembershipCategoryRequest },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateCategory>>,
  TError,
  { id: number; data: MembershipCategoryRequest },
  TContext
> => {
  const mutationKey = ["updateCategory"];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateCategory>>,
    { id: number; data: MembershipCategoryRequest }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateCategory(id, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateCategoryMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateCategory>>
>;
export type UpdateCategoryMutationBody = MembershipCategoryRequest;
export type UpdateCategoryMutationError = AxiosError<unknown>;

export const useUpdateCategory = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateCategory>>,
      TError,
      { id: number; data: MembershipCategoryRequest },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof updateCategory>>,
  TError,
  { id: number; data: MembershipCategoryRequest },
  TContext
> => {
  const mutationOptions = getUpdateCategoryMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

export const deleteCategory = (
  id: number,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<ApiResponse>> => {
  return axios.default.delete(
    `https://membership.uibfs.or.ug/uib-api/membership/categories/${id}`,
    options,
  );
};

export const getDeleteCategoryMutationOptions = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteCategory>>,
    TError,
    { id: number },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteCategory>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ["deleteCategory"];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteCategory>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return deleteCategory(id, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteCategoryMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteCategory>>
>;

export type DeleteCategoryMutationError = AxiosError<unknown>;

export const useDeleteCategory = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteCategory>>,
      TError,
      { id: number },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof deleteCategory>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationOptions = getDeleteCategoryMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Fetch a membership benefit by its identifier.
 * @summary Get membership benefit
 */
export const getById = (
  id: number,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<MembershipBenefitResponseDTO>> => {
  return axios.default.get(
    `https://membership.uibfs.or.ug/uib-api/membership/benefits/${id}`,
    options,
  );
};

export const getGetByIdQueryKey = (id?: number) => {
  return [
    `https://membership.uibfs.or.ug/uib-api/membership/benefits/${id}`,
  ] as const;
};

export const getGetByIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getById>>,
  TError = AxiosError<MembershipBenefitResponseDTO>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getById>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetByIdQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getById>>> = ({
    signal,
  }) => getById(id, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getById>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData>;
  };
};

export type GetByIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getById>>
>;
export type GetByIdQueryError = AxiosError<MembershipBenefitResponseDTO>;

export function useGetById<
  TData = Awaited<ReturnType<typeof getById>>,
  TError = AxiosError<MembershipBenefitResponseDTO>,
>(
  id: number,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getById>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getById>>,
          TError,
          Awaited<ReturnType<typeof getById>>
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetById<
  TData = Awaited<ReturnType<typeof getById>>,
  TError = AxiosError<MembershipBenefitResponseDTO>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getById>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getById>>,
          TError,
          Awaited<ReturnType<typeof getById>>
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetById<
  TData = Awaited<ReturnType<typeof getById>>,
  TError = AxiosError<MembershipBenefitResponseDTO>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getById>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get membership benefit
 */

export function useGetById<
  TData = Awaited<ReturnType<typeof getById>>,
  TError = AxiosError<MembershipBenefitResponseDTO>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getById>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetByIdQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Updates a benefit's title or description.
 * @summary Update membership benefit
 */
export const updateMembershipBenefit = (
  id: number,
  createMembershipBenefitDTO: CreateMembershipBenefitDTO,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<ApiResponse>> => {
  return axios.default.put(
    `https://membership.uibfs.or.ug/uib-api/membership/benefits/${id}`,
    createMembershipBenefitDTO,
    options,
  );
};

export const getUpdateMembershipBenefitMutationOptions = <
  TError = AxiosError<ApiResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateMembershipBenefit>>,
    TError,
    { id: number; data: CreateMembershipBenefitDTO },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateMembershipBenefit>>,
  TError,
  { id: number; data: CreateMembershipBenefitDTO },
  TContext
> => {
  const mutationKey = ["updateMembershipBenefit"];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateMembershipBenefit>>,
    { id: number; data: CreateMembershipBenefitDTO }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateMembershipBenefit(id, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateMembershipBenefitMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateMembershipBenefit>>
>;
export type UpdateMembershipBenefitMutationBody = CreateMembershipBenefitDTO;
export type UpdateMembershipBenefitMutationError = AxiosError<ApiResponse>;

/**
 * @summary Update membership benefit
 */
export const useUpdateMembershipBenefit = <
  TError = AxiosError<ApiResponse>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateMembershipBenefit>>,
      TError,
      { id: number; data: CreateMembershipBenefitDTO },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof updateMembershipBenefit>>,
  TError,
  { id: number; data: CreateMembershipBenefitDTO },
  TContext
> => {
  const mutationOptions = getUpdateMembershipBenefitMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Deletes a membership benefit by its identifier.
 * @summary Delete membership benefit
 */
export const deleteMembershipBenefit = (
  id: number,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<ApiResponse>> => {
  return axios.default.delete(
    `https://membership.uibfs.or.ug/uib-api/membership/benefits/${id}`,
    options,
  );
};

export const getDeleteMembershipBenefitMutationOptions = <
  TError = AxiosError<ApiResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteMembershipBenefit>>,
    TError,
    { id: number },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteMembershipBenefit>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ["deleteMembershipBenefit"];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteMembershipBenefit>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return deleteMembershipBenefit(id, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteMembershipBenefitMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteMembershipBenefit>>
>;

export type DeleteMembershipBenefitMutationError = AxiosError<ApiResponse>;

/**
 * @summary Delete membership benefit
 */
export const useDeleteMembershipBenefit = <
  TError = AxiosError<ApiResponse>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteMembershipBenefit>>,
      TError,
      { id: number },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof deleteMembershipBenefit>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationOptions = getDeleteMembershipBenefitMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Fetches a single application record using its identifier.
 * @summary Get application by id
 */
export const getApplicationById = (
  id: number,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<ApplicationResponseDTO>> => {
  return axios.default.get(
    `https://membership.uibfs.or.ug/uib-api/membership/application/${id}`,
    options,
  );
};

export const getGetApplicationByIdQueryKey = (id?: number) => {
  return [
    `https://membership.uibfs.or.ug/uib-api/membership/application/${id}`,
  ] as const;
};

export const getGetApplicationByIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getApplicationById>>,
  TError = AxiosError<ApiResponse>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApplicationById>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetApplicationByIdQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApplicationById>>
  > = ({ signal }) => getApplicationById(id, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getApplicationById>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetApplicationByIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApplicationById>>
>;
export type GetApplicationByIdQueryError = AxiosError<ApiResponse>;

export function useGetApplicationById<
  TData = Awaited<ReturnType<typeof getApplicationById>>,
  TError = AxiosError<ApiResponse>,
>(
  id: number,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApplicationById>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApplicationById>>,
          TError,
          Awaited<ReturnType<typeof getApplicationById>>
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetApplicationById<
  TData = Awaited<ReturnType<typeof getApplicationById>>,
  TError = AxiosError<ApiResponse>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApplicationById>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApplicationById>>,
          TError,
          Awaited<ReturnType<typeof getApplicationById>>
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetApplicationById<
  TData = Awaited<ReturnType<typeof getApplicationById>>,
  TError = AxiosError<ApiResponse>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApplicationById>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get application by id
 */

export function useGetApplicationById<
  TData = Awaited<ReturnType<typeof getApplicationById>>,
  TError = AxiosError<ApiResponse>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApplicationById>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetApplicationByIdQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Updates an existing application record.
 * @summary Update application
 */
export const updateApplication = (
  id: number,
  applicationUpdateDTO: ApplicationUpdateDTO,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<ApiResponse>> => {
  return axios.default.put(
    `https://membership.uibfs.or.ug/uib-api/membership/application/${id}`,
    applicationUpdateDTO,
    options,
  );
};

export const getUpdateApplicationMutationOptions = <
  TError = AxiosError<ApiResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateApplication>>,
    TError,
    { id: number; data: ApplicationUpdateDTO },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateApplication>>,
  TError,
  { id: number; data: ApplicationUpdateDTO },
  TContext
> => {
  const mutationKey = ["updateApplication"];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateApplication>>,
    { id: number; data: ApplicationUpdateDTO }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateApplication(id, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateApplicationMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateApplication>>
>;
export type UpdateApplicationMutationBody = ApplicationUpdateDTO;
export type UpdateApplicationMutationError = AxiosError<ApiResponse>;

/**
 * @summary Update application
 */
export const useUpdateApplication = <
  TError = AxiosError<ApiResponse>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateApplication>>,
      TError,
      { id: number; data: ApplicationUpdateDTO },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof updateApplication>>,
  TError,
  { id: number; data: ApplicationUpdateDTO },
  TContext
> => {
  const mutationOptions = getUpdateApplicationMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Deletes an application when allowed by business rules.
 * @summary Delete application
 */
export const deleteApplication = (
  id: number,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<ApiResponse>> => {
  return axios.default.delete(
    `https://membership.uibfs.or.ug/uib-api/membership/application/${id}`,
    options,
  );
};

export const getDeleteApplicationMutationOptions = <
  TError = AxiosError<ApiResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteApplication>>,
    TError,
    { id: number },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteApplication>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ["deleteApplication"];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteApplication>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return deleteApplication(id, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteApplicationMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteApplication>>
>;

export type DeleteApplicationMutationError = AxiosError<ApiResponse>;

/**
 * @summary Delete application
 */
export const useDeleteApplication = <
  TError = AxiosError<ApiResponse>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteApplication>>,
      TError,
      { id: number },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof deleteApplication>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationOptions = getDeleteApplicationMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

export const updateSetting = (
  settingId: string,
  updateSettingBody: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<string>> => {
  return axios.default.put(
    `https://membership.uibfs.or.ug/uib-api/api/content/settings/${settingId}`,
    updateSettingBody,
    {
      responseType: "text",
      ...options,
    },
  );
};

export const getUpdateSettingMutationOptions = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateSetting>>,
    TError,
    { settingId: string; data: string },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateSetting>>,
  TError,
  { settingId: string; data: string },
  TContext
> => {
  const mutationKey = ["updateSetting"];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateSetting>>,
    { settingId: string; data: string }
  > = (props) => {
    const { settingId, data } = props ?? {};

    return updateSetting(settingId, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateSettingMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateSetting>>
>;
export type UpdateSettingMutationBody = string;
export type UpdateSettingMutationError = AxiosError<unknown>;

export const useUpdateSetting = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateSetting>>,
      TError,
      { settingId: string; data: string },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof updateSetting>>,
  TError,
  { settingId: string; data: string },
  TContext
> => {
  const mutationOptions = getUpdateSettingMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

export const submitTrainingNeed = (
  trainingNeedSubmitDTO: TrainingNeedSubmitDTO,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<TrainingNeedResponseDTO[]>> => {
  return axios.default.post(
    `https://membership.uibfs.or.ug/uib-api/membership/training-needs/submit`,
    trainingNeedSubmitDTO,
    options,
  );
};

export const getSubmitTrainingNeedMutationOptions = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof submitTrainingNeed>>,
    TError,
    { data: TrainingNeedSubmitDTO },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof submitTrainingNeed>>,
  TError,
  { data: TrainingNeedSubmitDTO },
  TContext
> => {
  const mutationKey = ["submitTrainingNeed"];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof submitTrainingNeed>>,
    { data: TrainingNeedSubmitDTO }
  > = (props) => {
    const { data } = props ?? {};

    return submitTrainingNeed(data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SubmitTrainingNeedMutationResult = NonNullable<
  Awaited<ReturnType<typeof submitTrainingNeed>>
>;
export type SubmitTrainingNeedMutationBody = TrainingNeedSubmitDTO;
export type SubmitTrainingNeedMutationError = AxiosError<unknown>;

export const useSubmitTrainingNeed = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof submitTrainingNeed>>,
      TError,
      { data: TrainingNeedSubmitDTO },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof submitTrainingNeed>>,
  TError,
  { data: TrainingNeedSubmitDTO },
  TContext
> => {
  const mutationOptions = getSubmitTrainingNeedMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

export const bulkCreateTrainingNeeds = (
  trainingNeedBulkCreateDTO: TrainingNeedBulkCreateDTO,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<TrainingNeedResponseDTO[]>> => {
  return axios.default.post(
    `https://membership.uibfs.or.ug/uib-api/membership/training-needs/bulk`,
    trainingNeedBulkCreateDTO,
    options,
  );
};

export const getBulkCreateTrainingNeedsMutationOptions = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof bulkCreateTrainingNeeds>>,
    TError,
    { data: TrainingNeedBulkCreateDTO },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof bulkCreateTrainingNeeds>>,
  TError,
  { data: TrainingNeedBulkCreateDTO },
  TContext
> => {
  const mutationKey = ["bulkCreateTrainingNeeds"];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof bulkCreateTrainingNeeds>>,
    { data: TrainingNeedBulkCreateDTO }
  > = (props) => {
    const { data } = props ?? {};

    return bulkCreateTrainingNeeds(data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type BulkCreateTrainingNeedsMutationResult = NonNullable<
  Awaited<ReturnType<typeof bulkCreateTrainingNeeds>>
>;
export type BulkCreateTrainingNeedsMutationBody = TrainingNeedBulkCreateDTO;
export type BulkCreateTrainingNeedsMutationError = AxiosError<unknown>;

export const useBulkCreateTrainingNeeds = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof bulkCreateTrainingNeeds>>,
      TError,
      { data: TrainingNeedBulkCreateDTO },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof bulkCreateTrainingNeeds>>,
  TError,
  { data: TrainingNeedBulkCreateDTO },
  TContext
> => {
  const mutationOptions = getBulkCreateTrainingNeedsMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

export const bulkDeleteTrainingNeeds = (
  bulkDeleteTrainingNeedsBody: number[],
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<null>> => {
  return axios.default.post(
    `https://membership.uibfs.or.ug/uib-api/membership/training-needs/bulk-delete`,
    bulkDeleteTrainingNeedsBody,
    options,
  );
};

export const getBulkDeleteTrainingNeedsMutationOptions = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof bulkDeleteTrainingNeeds>>,
    TError,
    { data: number[] },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof bulkDeleteTrainingNeeds>>,
  TError,
  { data: number[] },
  TContext
> => {
  const mutationKey = ["bulkDeleteTrainingNeeds"];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof bulkDeleteTrainingNeeds>>,
    { data: number[] }
  > = (props) => {
    const { data } = props ?? {};

    return bulkDeleteTrainingNeeds(data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type BulkDeleteTrainingNeedsMutationResult = NonNullable<
  Awaited<ReturnType<typeof bulkDeleteTrainingNeeds>>
>;
export type BulkDeleteTrainingNeedsMutationBody = number[];
export type BulkDeleteTrainingNeedsMutationError = AxiosError<unknown>;

export const useBulkDeleteTrainingNeeds = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof bulkDeleteTrainingNeeds>>,
      TError,
      { data: number[] },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof bulkDeleteTrainingNeeds>>,
  TError,
  { data: number[] },
  TContext
> => {
  const mutationOptions = getBulkDeleteTrainingNeedsMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

export const playVideo = (
  videoId: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<PlayVideo200>> => {
  return axios.default.post(
    `https://membership.uibfs.or.ug/uib-api/membership/test/videos/${videoId}/play`,
    undefined,
    options,
  );
};

export const getPlayVideoMutationOptions = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof playVideo>>,
    TError,
    { videoId: string },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof playVideo>>,
  TError,
  { videoId: string },
  TContext
> => {
  const mutationKey = ["playVideo"];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof playVideo>>,
    { videoId: string }
  > = (props) => {
    const { videoId } = props ?? {};

    return playVideo(videoId, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PlayVideoMutationResult = NonNullable<
  Awaited<ReturnType<typeof playVideo>>
>;

export type PlayVideoMutationError = AxiosError<unknown>;

export const usePlayVideo = <TError = AxiosError<unknown>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof playVideo>>,
      TError,
      { videoId: string },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof playVideo>>,
  TError,
  { videoId: string },
  TContext
> => {
  const mutationOptions = getPlayVideoMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

export const shareResource = (
  resourceId: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<ShareResource200>> => {
  return axios.default.post(
    `https://membership.uibfs.or.ug/uib-api/membership/test/resources/${resourceId}/share`,
    undefined,
    options,
  );
};

export const getShareResourceMutationOptions = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof shareResource>>,
    TError,
    { resourceId: string },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof shareResource>>,
  TError,
  { resourceId: string },
  TContext
> => {
  const mutationKey = ["shareResource"];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof shareResource>>,
    { resourceId: string }
  > = (props) => {
    const { resourceId } = props ?? {};

    return shareResource(resourceId, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ShareResourceMutationResult = NonNullable<
  Awaited<ReturnType<typeof shareResource>>
>;

export type ShareResourceMutationError = AxiosError<unknown>;

export const useShareResource = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof shareResource>>,
      TError,
      { resourceId: string },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof shareResource>>,
  TError,
  { resourceId: string },
  TContext
> => {
  const mutationOptions = getShareResourceMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

export const generateBulkData = (
  count: number,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<GenerateBulkData200>> => {
  return axios.default.post(
    `https://membership.uibfs.or.ug/uib-api/membership/test/generate-bulk/${count}`,
    undefined,
    options,
  );
};

export const getGenerateBulkDataMutationOptions = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof generateBulkData>>,
    TError,
    { count: number },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof generateBulkData>>,
  TError,
  { count: number },
  TContext
> => {
  const mutationKey = ["generateBulkData"];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof generateBulkData>>,
    { count: number }
  > = (props) => {
    const { count } = props ?? {};

    return generateBulkData(count, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type GenerateBulkDataMutationResult = NonNullable<
  Awaited<ReturnType<typeof generateBulkData>>
>;

export type GenerateBulkDataMutationError = AxiosError<unknown>;

export const useGenerateBulkData = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof generateBulkData>>,
      TError,
      { count: number },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof generateBulkData>>,
  TError,
  { count: number },
  TContext
> => {
  const mutationOptions = getGenerateBulkDataMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

export const downloadDocument = (
  documentId: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<DownloadDocument200>> => {
  return axios.default.post(
    `https://membership.uibfs.or.ug/uib-api/membership/test/documents/${documentId}/download`,
    undefined,
    options,
  );
};

export const getDownloadDocumentMutationOptions = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof downloadDocument>>,
    TError,
    { documentId: string },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof downloadDocument>>,
  TError,
  { documentId: string },
  TContext
> => {
  const mutationKey = ["downloadDocument"];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof downloadDocument>>,
    { documentId: string }
  > = (props) => {
    const { documentId } = props ?? {};

    return downloadDocument(documentId, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DownloadDocumentMutationResult = NonNullable<
  Awaited<ReturnType<typeof downloadDocument>>
>;

export type DownloadDocumentMutationError = AxiosError<unknown>;

export const useDownloadDocument = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof downloadDocument>>,
      TError,
      { documentId: string },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof downloadDocument>>,
  TError,
  { documentId: string },
  TContext
> => {
  const mutationOptions = getDownloadDocumentMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

export const enrollCourse = (
  courseId: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<EnrollCourse200>> => {
  return axios.default.post(
    `https://membership.uibfs.or.ug/uib-api/membership/test/courses/${courseId}/enroll`,
    undefined,
    options,
  );
};

export const getEnrollCourseMutationOptions = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof enrollCourse>>,
    TError,
    { courseId: string },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof enrollCourse>>,
  TError,
  { courseId: string },
  TContext
> => {
  const mutationKey = ["enrollCourse"];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof enrollCourse>>,
    { courseId: string }
  > = (props) => {
    const { courseId } = props ?? {};

    return enrollCourse(courseId, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type EnrollCourseMutationResult = NonNullable<
  Awaited<ReturnType<typeof enrollCourse>>
>;

export type EnrollCourseMutationError = AxiosError<unknown>;

export const useEnrollCourse = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof enrollCourse>>,
      TError,
      { courseId: string },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof enrollCourse>>,
  TError,
  { courseId: string },
  TContext
> => {
  const mutationOptions = getEnrollCourseMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

export const completeCourse = (
  courseId: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<CompleteCourse200>> => {
  return axios.default.post(
    `https://membership.uibfs.or.ug/uib-api/membership/test/courses/${courseId}/complete`,
    undefined,
    options,
  );
};

export const getCompleteCourseMutationOptions = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof completeCourse>>,
    TError,
    { courseId: string },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof completeCourse>>,
  TError,
  { courseId: string },
  TContext
> => {
  const mutationKey = ["completeCourse"];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof completeCourse>>,
    { courseId: string }
  > = (props) => {
    const { courseId } = props ?? {};

    return completeCourse(courseId, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CompleteCourseMutationResult = NonNullable<
  Awaited<ReturnType<typeof completeCourse>>
>;

export type CompleteCourseMutationError = AxiosError<unknown>;

export const useCompleteCourse = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof completeCourse>>,
      TError,
      { courseId: string },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof completeCourse>>,
  TError,
  { courseId: string },
  TContext
> => {
  const mutationOptions = getCompleteCourseMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Persists a requirement without associating it to a category.
 * @summary Create requirement
 */
export const createRequirement = (
  requirementDto: RequirementDto,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<ApiResponse>> => {
  return axios.default.post(
    `https://membership.uibfs.or.ug/uib-api/membership/requirements/create`,
    requirementDto,
    options,
  );
};

export const getCreateRequirementMutationOptions = <
  TError = AxiosError<ApiResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createRequirement>>,
    TError,
    { data: RequirementDto },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createRequirement>>,
  TError,
  { data: RequirementDto },
  TContext
> => {
  const mutationKey = ["createRequirement"];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createRequirement>>,
    { data: RequirementDto }
  > = (props) => {
    const { data } = props ?? {};

    return createRequirement(data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateRequirementMutationResult = NonNullable<
  Awaited<ReturnType<typeof createRequirement>>
>;
export type CreateRequirementMutationBody = RequirementDto;
export type CreateRequirementMutationError = AxiosError<ApiResponse>;

/**
 * @summary Create requirement
 */
export const useCreateRequirement = <
  TError = AxiosError<ApiResponse>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createRequirement>>,
      TError,
      { data: RequirementDto },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof createRequirement>>,
  TError,
  { data: RequirementDto },
  TContext
> => {
  const mutationOptions = getCreateRequirementMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Marks the specified notification as read and returns the updated notification.
 * @summary Mark a notification as read
 */
export const markAsRead = (
  notificationId: number,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<InternalNotification>> => {
  return axios.default.post(
    `https://membership.uibfs.or.ug/uib-api/membership/notifications/${notificationId}/read`,
    undefined,
    options,
  );
};

export const getMarkAsReadMutationOptions = <
  TError = AxiosError<InternalNotification>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof markAsRead>>,
    TError,
    { notificationId: number },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof markAsRead>>,
  TError,
  { notificationId: number },
  TContext
> => {
  const mutationKey = ["markAsRead"];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof markAsRead>>,
    { notificationId: number }
  > = (props) => {
    const { notificationId } = props ?? {};

    return markAsRead(notificationId, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type MarkAsReadMutationResult = NonNullable<
  Awaited<ReturnType<typeof markAsRead>>
>;

export type MarkAsReadMutationError = AxiosError<InternalNotification>;

/**
 * @summary Mark a notification as read
 */
export const useMarkAsRead = <
  TError = AxiosError<InternalNotification>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof markAsRead>>,
      TError,
      { notificationId: number },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof markAsRead>>,
  TError,
  { notificationId: number },
  TContext
> => {
  const mutationOptions = getMarkAsReadMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Utility endpoint to generate a sample notification for testing.
 * @summary Create a test notification (sync)
 */
export const testSyncNotification = (
  userId: number,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<InternalNotificationTestSyncResponse>> => {
  return axios.default.post(
    `https://membership.uibfs.or.ug/uib-api/membership/notifications/sync/${userId}`,
    undefined,
    options,
  );
};

export const getTestSyncNotificationMutationOptions = <
  TError = AxiosError<InternalNotificationTestSyncResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof testSyncNotification>>,
    TError,
    { userId: number },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof testSyncNotification>>,
  TError,
  { userId: number },
  TContext
> => {
  const mutationKey = ["testSyncNotification"];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof testSyncNotification>>,
    { userId: number }
  > = (props) => {
    const { userId } = props ?? {};

    return testSyncNotification(userId, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type TestSyncNotificationMutationResult = NonNullable<
  Awaited<ReturnType<typeof testSyncNotification>>
>;

export type TestSyncNotificationMutationError =
  AxiosError<InternalNotificationTestSyncResponse>;

/**
 * @summary Create a test notification (sync)
 */
export const useTestSyncNotification = <
  TError = AxiosError<InternalNotificationTestSyncResponse>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof testSyncNotification>>,
      TError,
      { userId: number },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof testSyncNotification>>,
  TError,
  { userId: number },
  TContext
> => {
  const mutationOptions = getTestSyncNotificationMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Creates an invite link using the userId or email provided.
 * @summary Create a Discourse invite for a user
 */
export const createInvite = (
  discourseInviteRequest: DiscourseInviteRequest,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<CreateInvite200>> => {
  return axios.default.post(
    `https://membership.uibfs.or.ug/uib-api/membership/discourse/invites`,
    discourseInviteRequest,
    options,
  );
};

export const getCreateInviteMutationOptions = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createInvite>>,
    TError,
    { data: DiscourseInviteRequest },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createInvite>>,
  TError,
  { data: DiscourseInviteRequest },
  TContext
> => {
  const mutationKey = ["createInvite"];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createInvite>>,
    { data: DiscourseInviteRequest }
  > = (props) => {
    const { data } = props ?? {};

    return createInvite(data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateInviteMutationResult = NonNullable<
  Awaited<ReturnType<typeof createInvite>>
>;
export type CreateInviteMutationBody = DiscourseInviteRequest;
export type CreateInviteMutationError = AxiosError<unknown>;

/**
 * @summary Create a Discourse invite for a user
 */
export const useCreateInvite = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createInvite>>,
      TError,
      { data: DiscourseInviteRequest },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof createInvite>>,
  TError,
  { data: DiscourseInviteRequest },
  TContext
> => {
  const mutationOptions = getCreateInviteMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Creates a new membership programme in the catalogue.
 * @summary Create programme
 */
export const createCPDProgram = (
  programRequestDTO: ProgramRequestDTO,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<ProgramDTO>> => {
  return axios.default.post(
    `https://membership.uibfs.or.ug/uib-api/membership/create-cpd-program`,
    programRequestDTO,
    options,
  );
};

export const getCreateCPDProgramMutationOptions = <
  TError = AxiosError<ProgramDTO>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createCPDProgram>>,
    TError,
    { data: ProgramRequestDTO },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createCPDProgram>>,
  TError,
  { data: ProgramRequestDTO },
  TContext
> => {
  const mutationKey = ["createCPDProgram"];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createCPDProgram>>,
    { data: ProgramRequestDTO }
  > = (props) => {
    const { data } = props ?? {};

    return createCPDProgram(data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateCPDProgramMutationResult = NonNullable<
  Awaited<ReturnType<typeof createCPDProgram>>
>;
export type CreateCPDProgramMutationBody = ProgramRequestDTO;
export type CreateCPDProgramMutationError = AxiosError<ProgramDTO>;

/**
 * @summary Create programme
 */
export const useCreateCPDProgram = <
  TError = AxiosError<ProgramDTO>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createCPDProgram>>,
      TError,
      { data: ProgramRequestDTO },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof createCPDProgram>>,
  TError,
  { data: ProgramRequestDTO },
  TContext
> => {
  const mutationOptions = getCreateCPDProgramMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Create a new past CPD resource and optionally link it to an archived CPD event.
 * @summary Create a past CPD resource
 */
export const createPastResource = (
  pastCpdResourceCreate: PastCpdResourceCreate,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<ApiResponse>> => {
  return axios.default.post(
    `https://membership.uibfs.or.ug/uib-api/membership/cpd/past-resources/create`,
    pastCpdResourceCreate,
    options,
  );
};

export const getCreatePastResourceMutationOptions = <
  TError = AxiosError<ApiResponse | ApiResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createPastResource>>,
    TError,
    { data: PastCpdResourceCreate },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createPastResource>>,
  TError,
  { data: PastCpdResourceCreate },
  TContext
> => {
  const mutationKey = ["createPastResource"];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createPastResource>>,
    { data: PastCpdResourceCreate }
  > = (props) => {
    const { data } = props ?? {};

    return createPastResource(data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreatePastResourceMutationResult = NonNullable<
  Awaited<ReturnType<typeof createPastResource>>
>;
export type CreatePastResourceMutationBody = PastCpdResourceCreate;
export type CreatePastResourceMutationError = AxiosError<
  ApiResponse | ApiResponse
>;

/**
 * @summary Create a past CPD resource
 */
export const useCreatePastResource = <
  TError = AxiosError<ApiResponse | ApiResponse>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createPastResource>>,
      TError,
      { data: PastCpdResourceCreate },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof createPastResource>>,
  TError,
  { data: PastCpdResourceCreate },
  TContext
> => {
  const mutationOptions = getCreatePastResourceMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Create a single CPD points award and return the persisted record.
 * @summary Create CPD points award
 */
export const createSingleAward = (
  cPDPointsAwardCreateDTO: CPDPointsAwardCreateDTO,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<CPDPointsAwardResponseDTO>> => {
  return axios.default.post(
    `https://membership.uibfs.or.ug/uib-api/membership/cpd-points/awards`,
    cPDPointsAwardCreateDTO,
    options,
  );
};

export const getCreateSingleAwardMutationOptions = <
  TError = AxiosError<
    ErrorResponse | CPDPointsAwardResponseDTO | ErrorResponse
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createSingleAward>>,
    TError,
    { data: CPDPointsAwardCreateDTO },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createSingleAward>>,
  TError,
  { data: CPDPointsAwardCreateDTO },
  TContext
> => {
  const mutationKey = ["createSingleAward"];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createSingleAward>>,
    { data: CPDPointsAwardCreateDTO }
  > = (props) => {
    const { data } = props ?? {};

    return createSingleAward(data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateSingleAwardMutationResult = NonNullable<
  Awaited<ReturnType<typeof createSingleAward>>
>;
export type CreateSingleAwardMutationBody = CPDPointsAwardCreateDTO;
export type CreateSingleAwardMutationError = AxiosError<
  ErrorResponse | CPDPointsAwardResponseDTO | ErrorResponse
>;

/**
 * @summary Create CPD points award
 */
export const useCreateSingleAward = <
  TError = AxiosError<
    ErrorResponse | CPDPointsAwardResponseDTO | ErrorResponse
  >,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createSingleAward>>,
      TError,
      { data: CPDPointsAwardCreateDTO },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof createSingleAward>>,
  TError,
  { data: CPDPointsAwardCreateDTO },
  TContext
> => {
  const mutationOptions = getCreateSingleAwardMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Accepts a batch of CPD award records and persists them in a single operation.
 * @summary Bulk upload CPD points awards
 */
export const bulkUploadAwards = (
  cPDPointsAwardBulkUploadRequest: CPDPointsAwardBulkUploadRequest,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<ApiResponse>> => {
  return axios.default.post(
    `https://membership.uibfs.or.ug/uib-api/membership/cpd-points/awards/bulk`,
    cPDPointsAwardBulkUploadRequest,
    options,
  );
};

export const getBulkUploadAwardsMutationOptions = <
  TError = AxiosError<ErrorResponse | ApiResponse | ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof bulkUploadAwards>>,
    TError,
    { data: CPDPointsAwardBulkUploadRequest },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof bulkUploadAwards>>,
  TError,
  { data: CPDPointsAwardBulkUploadRequest },
  TContext
> => {
  const mutationKey = ["bulkUploadAwards"];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof bulkUploadAwards>>,
    { data: CPDPointsAwardBulkUploadRequest }
  > = (props) => {
    const { data } = props ?? {};

    return bulkUploadAwards(data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type BulkUploadAwardsMutationResult = NonNullable<
  Awaited<ReturnType<typeof bulkUploadAwards>>
>;
export type BulkUploadAwardsMutationBody = CPDPointsAwardBulkUploadRequest;
export type BulkUploadAwardsMutationError = AxiosError<
  ErrorResponse | ApiResponse | ErrorResponse
>;

/**
 * @summary Bulk upload CPD points awards
 */
export const useBulkUploadAwards = <
  TError = AxiosError<ErrorResponse | ApiResponse | ErrorResponse>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof bulkUploadAwards>>,
      TError,
      { data: CPDPointsAwardBulkUploadRequest },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof bulkUploadAwards>>,
  TError,
  { data: CPDPointsAwardBulkUploadRequest },
  TContext
> => {
  const mutationOptions = getBulkUploadAwardsMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Register a user for a CPD event
 * @summary Register for event
 */
export const registerForEvent = (
  eventId: number,
  params: RegisterForEventParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<ApiResponse>> => {
  return axios.default.post(
    `https://membership.uibfs.or.ug/uib-api/membership/cpd-events/${eventId}/register`,
    undefined,
    {
      ...options,
      params: { ...params, ...options?.params },
    },
  );
};

export const getRegisterForEventMutationOptions = <
  TError = AxiosError<ApiResponse | ApiResponse | ApiResponse | ApiResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof registerForEvent>>,
    TError,
    { eventId: number; params: RegisterForEventParams },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof registerForEvent>>,
  TError,
  { eventId: number; params: RegisterForEventParams },
  TContext
> => {
  const mutationKey = ["registerForEvent"];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof registerForEvent>>,
    { eventId: number; params: RegisterForEventParams }
  > = (props) => {
    const { eventId, params } = props ?? {};

    return registerForEvent(eventId, params, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RegisterForEventMutationResult = NonNullable<
  Awaited<ReturnType<typeof registerForEvent>>
>;

export type RegisterForEventMutationError = AxiosError<
  ApiResponse | ApiResponse | ApiResponse | ApiResponse
>;

/**
 * @summary Register for event
 */
export const useRegisterForEvent = <
  TError = AxiosError<ApiResponse | ApiResponse | ApiResponse | ApiResponse>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof registerForEvent>>,
      TError,
      { eventId: number; params: RegisterForEventParams },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof registerForEvent>>,
  TError,
  { eventId: number; params: RegisterForEventParams },
  TContext
> => {
  const mutationOptions = getRegisterForEventMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Issue a certificate to a participant
 * @summary Issue certificate
 */
export const issueCertificate = (
  participantId: number,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<SuccessResponse>> => {
  return axios.default.post(
    `https://membership.uibfs.or.ug/uib-api/membership/cpd-events/participants/${participantId}/certificate`,
    undefined,
    options,
  );
};

export const getIssueCertificateMutationOptions = <
  TError = AxiosError<
    SuccessResponse | SuccessResponse | SuccessResponse | SuccessResponse
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof issueCertificate>>,
    TError,
    { participantId: number },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof issueCertificate>>,
  TError,
  { participantId: number },
  TContext
> => {
  const mutationKey = ["issueCertificate"];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof issueCertificate>>,
    { participantId: number }
  > = (props) => {
    const { participantId } = props ?? {};

    return issueCertificate(participantId, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type IssueCertificateMutationResult = NonNullable<
  Awaited<ReturnType<typeof issueCertificate>>
>;

export type IssueCertificateMutationError = AxiosError<
  SuccessResponse | SuccessResponse | SuccessResponse | SuccessResponse
>;

/**
 * @summary Issue certificate
 */
export const useIssueCertificate = <
  TError = AxiosError<
    SuccessResponse | SuccessResponse | SuccessResponse | SuccessResponse
  >,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof issueCertificate>>,
      TError,
      { participantId: number },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof issueCertificate>>,
  TError,
  { participantId: number },
  TContext
> => {
  const mutationOptions = getIssueCertificateMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

export const markAttendance = (
  participantId: number,
  attendanceMarkDTO: AttendanceMarkDTO,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<ErrorResponse>> => {
  return axios.default.post(
    `https://membership.uibfs.or.ug/uib-api/membership/cpd-events/participants/${participantId}/attendance`,
    attendanceMarkDTO,
    options,
  );
};

export const getMarkAttendanceMutationOptions = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof markAttendance>>,
    TError,
    { participantId: number; data: AttendanceMarkDTO },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof markAttendance>>,
  TError,
  { participantId: number; data: AttendanceMarkDTO },
  TContext
> => {
  const mutationKey = ["markAttendance"];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof markAttendance>>,
    { participantId: number; data: AttendanceMarkDTO }
  > = (props) => {
    const { participantId, data } = props ?? {};

    return markAttendance(participantId, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type MarkAttendanceMutationResult = NonNullable<
  Awaited<ReturnType<typeof markAttendance>>
>;
export type MarkAttendanceMutationBody = AttendanceMarkDTO;
export type MarkAttendanceMutationError = AxiosError<unknown>;

export const useMarkAttendance = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof markAttendance>>,
      TError,
      { participantId: number; data: AttendanceMarkDTO },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof markAttendance>>,
  TError,
  { participantId: number; data: AttendanceMarkDTO },
  TContext
> => {
  const mutationOptions = getMarkAttendanceMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Create a new CPD event
 * @summary Create new CPD event
 */
export const createEvent = (
  cPDEventCreateDTO: CPDEventCreateDTO,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<CPDEventResponseDTO>> => {
  return axios.default.post(
    `https://membership.uibfs.or.ug/uib-api/membership/cpd-events/create`,
    cPDEventCreateDTO,
    options,
  );
};

export const getCreateEventMutationOptions = <
  TError = AxiosError<ErrorResponse | ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createEvent>>,
    TError,
    { data: CPDEventCreateDTO },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createEvent>>,
  TError,
  { data: CPDEventCreateDTO },
  TContext
> => {
  const mutationKey = ["createEvent"];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createEvent>>,
    { data: CPDEventCreateDTO }
  > = (props) => {
    const { data } = props ?? {};

    return createEvent(data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateEventMutationResult = NonNullable<
  Awaited<ReturnType<typeof createEvent>>
>;
export type CreateEventMutationBody = CPDEventCreateDTO;
export type CreateEventMutationError = AxiosError<
  ErrorResponse | ErrorResponse
>;

/**
 * @summary Create new CPD event
 */
export const useCreateEvent = <
  TError = AxiosError<ErrorResponse | ErrorResponse>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createEvent>>,
      TError,
      { data: CPDEventCreateDTO },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof createEvent>>,
  TError,
  { data: CPDEventCreateDTO },
  TContext
> => {
  const mutationOptions = getCreateEventMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Removes the authenticated user from the specified community.
 * @summary Leave a community/chapter
 */
export const leaveCommunity = (
  communityId: number,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<LeaveCommunity200>> => {
  return axios.default.post(
    `https://membership.uibfs.or.ug/uib-api/membership/communities/${communityId}/leave`,
    undefined,
    options,
  );
};

export const getLeaveCommunityMutationOptions = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof leaveCommunity>>,
    TError,
    { communityId: number },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof leaveCommunity>>,
  TError,
  { communityId: number },
  TContext
> => {
  const mutationKey = ["leaveCommunity"];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof leaveCommunity>>,
    { communityId: number }
  > = (props) => {
    const { communityId } = props ?? {};

    return leaveCommunity(communityId, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type LeaveCommunityMutationResult = NonNullable<
  Awaited<ReturnType<typeof leaveCommunity>>
>;

export type LeaveCommunityMutationError = AxiosError<unknown>;

/**
 * @summary Leave a community/chapter
 */
export const useLeaveCommunity = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof leaveCommunity>>,
      TError,
      { communityId: number },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof leaveCommunity>>,
  TError,
  { communityId: number },
  TContext
> => {
  const mutationOptions = getLeaveCommunityMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Adds the authenticated user to the community roster.
 * @summary Join a community/chapter
 */
export const joinCommunity = (
  communityId: number,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<JoinCommunity200>> => {
  return axios.default.post(
    `https://membership.uibfs.or.ug/uib-api/membership/communities/${communityId}/join`,
    undefined,
    options,
  );
};

export const getJoinCommunityMutationOptions = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof joinCommunity>>,
    TError,
    { communityId: number },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof joinCommunity>>,
  TError,
  { communityId: number },
  TContext
> => {
  const mutationKey = ["joinCommunity"];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof joinCommunity>>,
    { communityId: number }
  > = (props) => {
    const { communityId } = props ?? {};

    return joinCommunity(communityId, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type JoinCommunityMutationResult = NonNullable<
  Awaited<ReturnType<typeof joinCommunity>>
>;

export type JoinCommunityMutationError = AxiosError<unknown>;

/**
 * @summary Join a community/chapter
 */
export const useJoinCommunity = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof joinCommunity>>,
      TError,
      { communityId: number },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof joinCommunity>>,
  TError,
  { communityId: number },
  TContext
> => {
  const mutationOptions = getJoinCommunityMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Returns all upcoming and past events for the requested community.
 * @summary List events/meetups for a community
 */
export const listEvents = (
  communityId: number,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<CommunityEventDTO[]>> => {
  return axios.default.get(
    `https://membership.uibfs.or.ug/uib-api/membership/communities/${communityId}/events`,
    options,
  );
};

export const getListEventsQueryKey = (communityId?: number) => {
  return [
    `https://membership.uibfs.or.ug/uib-api/membership/communities/${communityId}/events`,
  ] as const;
};

export const getListEventsQueryOptions = <
  TData = Awaited<ReturnType<typeof listEvents>>,
  TError = AxiosError<unknown>,
>(
  communityId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listEvents>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListEventsQueryKey(communityId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listEvents>>> = ({
    signal,
  }) => listEvents(communityId, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!communityId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof listEvents>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ListEventsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listEvents>>
>;
export type ListEventsQueryError = AxiosError<unknown>;

export function useListEvents<
  TData = Awaited<ReturnType<typeof listEvents>>,
  TError = AxiosError<unknown>,
>(
  communityId: number,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listEvents>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listEvents>>,
          TError,
          Awaited<ReturnType<typeof listEvents>>
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useListEvents<
  TData = Awaited<ReturnType<typeof listEvents>>,
  TError = AxiosError<unknown>,
>(
  communityId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listEvents>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listEvents>>,
          TError,
          Awaited<ReturnType<typeof listEvents>>
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListEvents<
  TData = Awaited<ReturnType<typeof listEvents>>,
  TError = AxiosError<unknown>,
>(
  communityId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listEvents>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List events/meetups for a community
 */

export function useListEvents<
  TData = Awaited<ReturnType<typeof listEvents>>,
  TError = AxiosError<unknown>,
>(
  communityId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listEvents>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getListEventsQueryOptions(communityId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Schedules a new meetup on behalf of the authenticated community member.
 * @summary Create an event/meetup in a community
 */
export const createEvent1 = (
  communityId: number,
  communityEventCreateDTO: CommunityEventCreateDTO,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<CommunityEventDTO>> => {
  return axios.default.post(
    `https://membership.uibfs.or.ug/uib-api/membership/communities/${communityId}/events`,
    communityEventCreateDTO,
    options,
  );
};

export const getCreateEvent1MutationOptions = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createEvent1>>,
    TError,
    { communityId: number; data: CommunityEventCreateDTO },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createEvent1>>,
  TError,
  { communityId: number; data: CommunityEventCreateDTO },
  TContext
> => {
  const mutationKey = ["createEvent1"];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createEvent1>>,
    { communityId: number; data: CommunityEventCreateDTO }
  > = (props) => {
    const { communityId, data } = props ?? {};

    return createEvent1(communityId, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateEvent1MutationResult = NonNullable<
  Awaited<ReturnType<typeof createEvent1>>
>;
export type CreateEvent1MutationBody = CommunityEventCreateDTO;
export type CreateEvent1MutationError = AxiosError<unknown>;

/**
 * @summary Create an event/meetup in a community
 */
export const useCreateEvent1 = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createEvent1>>,
      TError,
      { communityId: number; data: CommunityEventCreateDTO },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof createEvent1>>,
  TError,
  { communityId: number; data: CommunityEventCreateDTO },
  TContext
> => {
  const mutationOptions = getCreateEvent1MutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Registers the current user for the requested event.
 * @summary Attend / register for an event/meetup
 */
export const attendEvent = (
  eventId: number,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<ApiResponse>> => {
  return axios.default.post(
    `https://membership.uibfs.or.ug/uib-api/membership/communities/events/${eventId}/attend`,
    undefined,
    options,
  );
};

export const getAttendEventMutationOptions = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof attendEvent>>,
    TError,
    { eventId: number },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof attendEvent>>,
  TError,
  { eventId: number },
  TContext
> => {
  const mutationKey = ["attendEvent"];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof attendEvent>>,
    { eventId: number }
  > = (props) => {
    const { eventId } = props ?? {};

    return attendEvent(eventId, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AttendEventMutationResult = NonNullable<
  Awaited<ReturnType<typeof attendEvent>>
>;

export type AttendEventMutationError = AxiosError<unknown>;

/**
 * @summary Attend / register for an event/meetup
 */
export const useAttendEvent = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof attendEvent>>,
      TError,
      { eventId: number },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof attendEvent>>,
  TError,
  { eventId: number },
  TContext
> => {
  const mutationOptions = getAttendEventMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Creates a community and enrolls the caller as its administrator.
 * @summary Create a new community/chapter
 */
export const createCommunity = (
  communityCreateDTO: CommunityCreateDTO,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<ApiResponse>> => {
  return axios.default.post(
    `https://membership.uibfs.or.ug/uib-api/membership/communities/create`,
    communityCreateDTO,
    options,
  );
};

export const getCreateCommunityMutationOptions = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createCommunity>>,
    TError,
    { data: CommunityCreateDTO },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createCommunity>>,
  TError,
  { data: CommunityCreateDTO },
  TContext
> => {
  const mutationKey = ["createCommunity"];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createCommunity>>,
    { data: CommunityCreateDTO }
  > = (props) => {
    const { data } = props ?? {};

    return createCommunity(data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateCommunityMutationResult = NonNullable<
  Awaited<ReturnType<typeof createCommunity>>
>;
export type CreateCommunityMutationBody = CommunityCreateDTO;
export type CreateCommunityMutationError = AxiosError<unknown>;

/**
 * @summary Create a new community/chapter
 */
export const useCreateCommunity = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createCommunity>>,
      TError,
      { data: CommunityCreateDTO },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof createCommunity>>,
  TError,
  { data: CommunityCreateDTO },
  TContext
> => {
  const mutationOptions = getCreateCommunityMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

export const addRequirementsToCategory = (
  categoryId: number,
  requirementDto: RequirementDto[],
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<ApiResponse>> => {
  return axios.default.post(
    `https://membership.uibfs.or.ug/uib-api/membership/categories/${categoryId}/requirements/add`,
    requirementDto,
    options,
  );
};

export const getAddRequirementsToCategoryMutationOptions = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof addRequirementsToCategory>>,
    TError,
    { categoryId: number; data: RequirementDto[] },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof addRequirementsToCategory>>,
  TError,
  { categoryId: number; data: RequirementDto[] },
  TContext
> => {
  const mutationKey = ["addRequirementsToCategory"];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof addRequirementsToCategory>>,
    { categoryId: number; data: RequirementDto[] }
  > = (props) => {
    const { categoryId, data } = props ?? {};

    return addRequirementsToCategory(categoryId, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AddRequirementsToCategoryMutationResult = NonNullable<
  Awaited<ReturnType<typeof addRequirementsToCategory>>
>;
export type AddRequirementsToCategoryMutationBody = RequirementDto[];
export type AddRequirementsToCategoryMutationError = AxiosError<unknown>;

export const useAddRequirementsToCategory = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof addRequirementsToCategory>>,
      TError,
      { categoryId: number; data: RequirementDto[] },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof addRequirementsToCategory>>,
  TError,
  { categoryId: number; data: RequirementDto[] },
  TContext
> => {
  const mutationOptions = getAddRequirementsToCategoryMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

export const createCategory = (
  membershipCategoryRequest: MembershipCategoryRequest,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<ApiResponse>> => {
  return axios.default.post(
    `https://membership.uibfs.or.ug/uib-api/membership/categories/create`,
    membershipCategoryRequest,
    options,
  );
};

export const getCreateCategoryMutationOptions = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createCategory>>,
    TError,
    { data: MembershipCategoryRequest },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createCategory>>,
  TError,
  { data: MembershipCategoryRequest },
  TContext
> => {
  const mutationKey = ["createCategory"];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createCategory>>,
    { data: MembershipCategoryRequest }
  > = (props) => {
    const { data } = props ?? {};

    return createCategory(data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateCategoryMutationResult = NonNullable<
  Awaited<ReturnType<typeof createCategory>>
>;
export type CreateCategoryMutationBody = MembershipCategoryRequest;
export type CreateCategoryMutationError = AxiosError<unknown>;

export const useCreateCategory = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createCategory>>,
      TError,
      { data: MembershipCategoryRequest },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof createCategory>>,
  TError,
  { data: MembershipCategoryRequest },
  TContext
> => {
  const mutationOptions = getCreateCategoryMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Creates a new membership benefit entry.
 * @summary Create membership benefit
 */
export const createMembershipBenefit = (
  createMembershipBenefitDTO: CreateMembershipBenefitDTO,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<ApiResponse>> => {
  return axios.default.post(
    `https://membership.uibfs.or.ug/uib-api/membership/benefits/create`,
    createMembershipBenefitDTO,
    options,
  );
};

export const getCreateMembershipBenefitMutationOptions = <
  TError = AxiosError<ApiResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createMembershipBenefit>>,
    TError,
    { data: CreateMembershipBenefitDTO },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createMembershipBenefit>>,
  TError,
  { data: CreateMembershipBenefitDTO },
  TContext
> => {
  const mutationKey = ["createMembershipBenefit"];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createMembershipBenefit>>,
    { data: CreateMembershipBenefitDTO }
  > = (props) => {
    const { data } = props ?? {};

    return createMembershipBenefit(data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateMembershipBenefitMutationResult = NonNullable<
  Awaited<ReturnType<typeof createMembershipBenefit>>
>;
export type CreateMembershipBenefitMutationBody = CreateMembershipBenefitDTO;
export type CreateMembershipBenefitMutationError = AxiosError<ApiResponse>;

/**
 * @summary Create membership benefit
 */
export const useCreateMembershipBenefit = <
  TError = AxiosError<ApiResponse>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createMembershipBenefit>>,
      TError,
      { data: CreateMembershipBenefitDTO },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof createMembershipBenefit>>,
  TError,
  { data: CreateMembershipBenefitDTO },
  TContext
> => {
  const mutationOptions = getCreateMembershipBenefitMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Sends correction notes to the applicant and issues login credentials so they can update their application.
 * @summary Request application corrections
 */
export const requestApplicationCorrection = (
  id: number,
  applicationCorrectionRequestDTO: ApplicationCorrectionRequestDTO,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<ApiResponse>> => {
  return axios.default.post(
    `https://membership.uibfs.or.ug/uib-api/membership/application/${id}/request-correction`,
    applicationCorrectionRequestDTO,
    options,
  );
};

export const getRequestApplicationCorrectionMutationOptions = <
  TError = AxiosError<ApiResponse | ApiResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof requestApplicationCorrection>>,
    TError,
    { id: number; data: ApplicationCorrectionRequestDTO },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof requestApplicationCorrection>>,
  TError,
  { id: number; data: ApplicationCorrectionRequestDTO },
  TContext
> => {
  const mutationKey = ["requestApplicationCorrection"];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof requestApplicationCorrection>>,
    { id: number; data: ApplicationCorrectionRequestDTO }
  > = (props) => {
    const { id, data } = props ?? {};

    return requestApplicationCorrection(id, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RequestApplicationCorrectionMutationResult = NonNullable<
  Awaited<ReturnType<typeof requestApplicationCorrection>>
>;
export type RequestApplicationCorrectionMutationBody =
  ApplicationCorrectionRequestDTO;
export type RequestApplicationCorrectionMutationError = AxiosError<
  ApiResponse | ApiResponse
>;

/**
 * @summary Request application corrections
 */
export const useRequestApplicationCorrection = <
  TError = AxiosError<ApiResponse | ApiResponse>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof requestApplicationCorrection>>,
      TError,
      { id: number; data: ApplicationCorrectionRequestDTO },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof requestApplicationCorrection>>,
  TError,
  { id: number; data: ApplicationCorrectionRequestDTO },
  TContext
> => {
  const mutationOptions =
    getRequestApplicationCorrectionMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary List renewals for an application (paginated)
 */
export const listRenewals = (
  id: number,
  params?: ListRenewalsParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<PageMembershipRenewalResponseDTO>> => {
  return axios.default.get(
    `https://membership.uibfs.or.ug/uib-api/membership/application/${id}/renewals`,
    {
      ...options,
      params: { ...params, ...options?.params },
    },
  );
};

export const getListRenewalsQueryKey = (
  id?: number,
  params?: ListRenewalsParams,
) => {
  return [
    `https://membership.uibfs.or.ug/uib-api/membership/application/${id}/renewals`,
    ...(params ? [params] : []),
  ] as const;
};

export const getListRenewalsQueryOptions = <
  TData = Awaited<ReturnType<typeof listRenewals>>,
  TError = AxiosError<unknown>,
>(
  id: number,
  params?: ListRenewalsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listRenewals>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListRenewalsQueryKey(id, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listRenewals>>> = ({
    signal,
  }) => listRenewals(id, params, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof listRenewals>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ListRenewalsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listRenewals>>
>;
export type ListRenewalsQueryError = AxiosError<unknown>;

export function useListRenewals<
  TData = Awaited<ReturnType<typeof listRenewals>>,
  TError = AxiosError<unknown>,
>(
  id: number,
  params: undefined | ListRenewalsParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listRenewals>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listRenewals>>,
          TError,
          Awaited<ReturnType<typeof listRenewals>>
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useListRenewals<
  TData = Awaited<ReturnType<typeof listRenewals>>,
  TError = AxiosError<unknown>,
>(
  id: number,
  params?: ListRenewalsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listRenewals>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listRenewals>>,
          TError,
          Awaited<ReturnType<typeof listRenewals>>
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListRenewals<
  TData = Awaited<ReturnType<typeof listRenewals>>,
  TError = AxiosError<unknown>,
>(
  id: number,
  params?: ListRenewalsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listRenewals>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List renewals for an application (paginated)
 */

export function useListRenewals<
  TData = Awaited<ReturnType<typeof listRenewals>>,
  TError = AxiosError<unknown>,
>(
  id: number,
  params?: ListRenewalsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listRenewals>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getListRenewalsQueryOptions(id, params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const createRenewal = (
  id: number,
  membershipRenewalCreateDTO: MembershipRenewalCreateDTO,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<ApiResponse>> => {
  return axios.default.post(
    `https://membership.uibfs.or.ug/uib-api/membership/application/${id}/renewals`,
    membershipRenewalCreateDTO,
    options,
  );
};

export const getCreateRenewalMutationOptions = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createRenewal>>,
    TError,
    { id: number; data: MembershipRenewalCreateDTO },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createRenewal>>,
  TError,
  { id: number; data: MembershipRenewalCreateDTO },
  TContext
> => {
  const mutationKey = ["createRenewal"];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createRenewal>>,
    { id: number; data: MembershipRenewalCreateDTO }
  > = (props) => {
    const { id, data } = props ?? {};

    return createRenewal(id, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateRenewalMutationResult = NonNullable<
  Awaited<ReturnType<typeof createRenewal>>
>;
export type CreateRenewalMutationBody = MembershipRenewalCreateDTO;
export type CreateRenewalMutationError = AxiosError<unknown>;

export const useCreateRenewal = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createRenewal>>,
      TError,
      { id: number; data: MembershipRenewalCreateDTO },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof createRenewal>>,
  TError,
  { id: number; data: MembershipRenewalCreateDTO },
  TContext
> => {
  const mutationOptions = getCreateRenewalMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Renews a membership with category, payment reference and proof of payment.
 * @summary Submit a membership renewal request
 */
export const handleRenewalApplication = (
  id: number,
  membershipRenewalApplicationDTO: MembershipRenewalApplicationDTO,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<ApiResponse>> => {
  return axios.default.post(
    `https://membership.uibfs.or.ug/uib-api/membership/application/${id}/renew-application`,
    membershipRenewalApplicationDTO,
    options,
  );
};

export const getHandleRenewalApplicationMutationOptions = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof handleRenewalApplication>>,
    TError,
    { id: number; data: MembershipRenewalApplicationDTO },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof handleRenewalApplication>>,
  TError,
  { id: number; data: MembershipRenewalApplicationDTO },
  TContext
> => {
  const mutationKey = ["handleRenewalApplication"];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof handleRenewalApplication>>,
    { id: number; data: MembershipRenewalApplicationDTO }
  > = (props) => {
    const { id, data } = props ?? {};

    return handleRenewalApplication(id, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type HandleRenewalApplicationMutationResult = NonNullable<
  Awaited<ReturnType<typeof handleRenewalApplication>>
>;
export type HandleRenewalApplicationMutationBody =
  MembershipRenewalApplicationDTO;
export type HandleRenewalApplicationMutationError = AxiosError<unknown>;

/**
 * @summary Submit a membership renewal request
 */
export const useHandleRenewalApplication = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof handleRenewalApplication>>,
      TError,
      { id: number; data: MembershipRenewalApplicationDTO },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof handleRenewalApplication>>,
  TError,
  { id: number; data: MembershipRenewalApplicationDTO },
  TContext
> => {
  const mutationOptions = getHandleRenewalApplicationMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

export const triggerBirthdayEmails = (
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<ApiResponse>> => {
  return axios.default.post(
    `https://membership.uibfs.or.ug/uib-api/membership/application/birthdays/send-now`,
    undefined,
    options,
  );
};

export const getTriggerBirthdayEmailsMutationOptions = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof triggerBirthdayEmails>>,
    TError,
    void,
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof triggerBirthdayEmails>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["triggerBirthdayEmails"];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof triggerBirthdayEmails>>,
    void
  > = () => {
    return triggerBirthdayEmails(axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type TriggerBirthdayEmailsMutationResult = NonNullable<
  Awaited<ReturnType<typeof triggerBirthdayEmails>>
>;

export type TriggerBirthdayEmailsMutationError = AxiosError<unknown>;

export const useTriggerBirthdayEmails = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof triggerBirthdayEmails>>,
      TError,
      void,
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof triggerBirthdayEmails>>,
  TError,
  void,
  TContext
> => {
  const mutationOptions = getTriggerBirthdayEmailsMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Creates a new membership application on behalf of the current user.
 * @summary Submit new application
 */
export const createApplication = (
  applicationCreateDTO: ApplicationCreateDTO,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<ApiResponse>> => {
  return axios.default.post(
    `https://membership.uibfs.or.ug/uib-api/membership/application/apply`,
    applicationCreateDTO,
    options,
  );
};

export const getCreateApplicationMutationOptions = <
  TError = AxiosError<ApiResponse | ApiResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createApplication>>,
    TError,
    { data: ApplicationCreateDTO },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createApplication>>,
  TError,
  { data: ApplicationCreateDTO },
  TContext
> => {
  const mutationKey = ["createApplication"];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createApplication>>,
    { data: ApplicationCreateDTO }
  > = (props) => {
    const { data } = props ?? {};

    return createApplication(data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateApplicationMutationResult = NonNullable<
  Awaited<ReturnType<typeof createApplication>>
>;
export type CreateApplicationMutationBody = ApplicationCreateDTO;
export type CreateApplicationMutationError = AxiosError<
  ApiResponse | ApiResponse
>;

/**
 * @summary Submit new application
 */
export const useCreateApplication = <
  TError = AxiosError<ApiResponse | ApiResponse>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createApplication>>,
      TError,
      { data: ApplicationCreateDTO },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof createApplication>>,
  TError,
  { data: ApplicationCreateDTO },
  TContext
> => {
  const mutationOptions = getCreateApplicationMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

export const playVideo1 = (
  videoId: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<string>> => {
  return axios.default.post(
    `https://membership.uibfs.or.ug/uib-api/api/content/videos/${videoId}/play`,
    undefined,
    {
      responseType: "text",
      ...options,
    },
  );
};

export const getPlayVideo1MutationOptions = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof playVideo1>>,
    TError,
    { videoId: string },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof playVideo1>>,
  TError,
  { videoId: string },
  TContext
> => {
  const mutationKey = ["playVideo1"];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof playVideo1>>,
    { videoId: string }
  > = (props) => {
    const { videoId } = props ?? {};

    return playVideo1(videoId, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PlayVideo1MutationResult = NonNullable<
  Awaited<ReturnType<typeof playVideo1>>
>;

export type PlayVideo1MutationError = AxiosError<unknown>;

export const usePlayVideo1 = <TError = AxiosError<unknown>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof playVideo1>>,
      TError,
      { videoId: string },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof playVideo1>>,
  TError,
  { videoId: string },
  TContext
> => {
  const mutationOptions = getPlayVideo1MutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

export const shareResource1 = (
  resourceId: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<string>> => {
  return axios.default.post(
    `https://membership.uibfs.or.ug/uib-api/api/content/resources/${resourceId}/share`,
    undefined,
    {
      responseType: "text",
      ...options,
    },
  );
};

export const getShareResource1MutationOptions = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof shareResource1>>,
    TError,
    { resourceId: string },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof shareResource1>>,
  TError,
  { resourceId: string },
  TContext
> => {
  const mutationKey = ["shareResource1"];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof shareResource1>>,
    { resourceId: string }
  > = (props) => {
    const { resourceId } = props ?? {};

    return shareResource1(resourceId, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ShareResource1MutationResult = NonNullable<
  Awaited<ReturnType<typeof shareResource1>>
>;

export type ShareResource1MutationError = AxiosError<unknown>;

export const useShareResource1 = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof shareResource1>>,
      TError,
      { resourceId: string },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof shareResource1>>,
  TError,
  { resourceId: string },
  TContext
> => {
  const mutationOptions = getShareResource1MutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

export const uploadFile = (
  folderId: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<string>> => {
  return axios.default.post(
    `https://membership.uibfs.or.ug/uib-api/api/content/files/${folderId}/upload`,
    undefined,
    {
      responseType: "text",
      ...options,
    },
  );
};

export const getUploadFileMutationOptions = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof uploadFile>>,
    TError,
    { folderId: string },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof uploadFile>>,
  TError,
  { folderId: string },
  TContext
> => {
  const mutationKey = ["uploadFile"];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof uploadFile>>,
    { folderId: string }
  > = (props) => {
    const { folderId } = props ?? {};

    return uploadFile(folderId, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UploadFileMutationResult = NonNullable<
  Awaited<ReturnType<typeof uploadFile>>
>;

export type UploadFileMutationError = AxiosError<unknown>;

export const useUploadFile = <TError = AxiosError<unknown>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof uploadFile>>,
      TError,
      { folderId: string },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof uploadFile>>,
  TError,
  { folderId: string },
  TContext
> => {
  const mutationOptions = getUploadFileMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

export const downloadDocument1 = (
  documentId: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<string[]>> => {
  return axios.default.post(
    `https://membership.uibfs.or.ug/uib-api/api/content/documents/${documentId}/download`,
    undefined,
    options,
  );
};

export const getDownloadDocument1MutationOptions = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof downloadDocument1>>,
    TError,
    { documentId: string },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof downloadDocument1>>,
  TError,
  { documentId: string },
  TContext
> => {
  const mutationKey = ["downloadDocument1"];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof downloadDocument1>>,
    { documentId: string }
  > = (props) => {
    const { documentId } = props ?? {};

    return downloadDocument1(documentId, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DownloadDocument1MutationResult = NonNullable<
  Awaited<ReturnType<typeof downloadDocument1>>
>;

export type DownloadDocument1MutationError = AxiosError<unknown>;

export const useDownloadDocument1 = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof downloadDocument1>>,
      TError,
      { documentId: string },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof downloadDocument1>>,
  TError,
  { documentId: string },
  TContext
> => {
  const mutationOptions = getDownloadDocument1MutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

export const enrollCourse1 = (
  courseId: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<string>> => {
  return axios.default.post(
    `https://membership.uibfs.or.ug/uib-api/api/content/courses/${courseId}/enroll`,
    undefined,
    {
      responseType: "text",
      ...options,
    },
  );
};

export const getEnrollCourse1MutationOptions = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof enrollCourse1>>,
    TError,
    { courseId: string },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof enrollCourse1>>,
  TError,
  { courseId: string },
  TContext
> => {
  const mutationKey = ["enrollCourse1"];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof enrollCourse1>>,
    { courseId: string }
  > = (props) => {
    const { courseId } = props ?? {};

    return enrollCourse1(courseId, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type EnrollCourse1MutationResult = NonNullable<
  Awaited<ReturnType<typeof enrollCourse1>>
>;

export type EnrollCourse1MutationError = AxiosError<unknown>;

export const useEnrollCourse1 = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof enrollCourse1>>,
      TError,
      { courseId: string },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof enrollCourse1>>,
  TError,
  { courseId: string },
  TContext
> => {
  const mutationOptions = getEnrollCourse1MutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

export const completeCourse1 = (
  courseId: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<string>> => {
  return axios.default.post(
    `https://membership.uibfs.or.ug/uib-api/api/content/courses/${courseId}/complete`,
    undefined,
    {
      responseType: "text",
      ...options,
    },
  );
};

export const getCompleteCourse1MutationOptions = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof completeCourse1>>,
    TError,
    { courseId: string },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof completeCourse1>>,
  TError,
  { courseId: string },
  TContext
> => {
  const mutationKey = ["completeCourse1"];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof completeCourse1>>,
    { courseId: string }
  > = (props) => {
    const { courseId } = props ?? {};

    return completeCourse1(courseId, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CompleteCourse1MutationResult = NonNullable<
  Awaited<ReturnType<typeof completeCourse1>>
>;

export type CompleteCourse1MutationError = AxiosError<unknown>;

export const useCompleteCourse1 = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof completeCourse1>>,
      TError,
      { courseId: string },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof completeCourse1>>,
  TError,
  { courseId: string },
  TContext
> => {
  const mutationOptions = getCompleteCourse1MutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Update the status of a CPD event
 * @summary Change event status
 */
export const changeEventStatus = (
  id: number,
  params: ChangeEventStatusParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<SuccessResponse>> => {
  return axios.default.patch(
    `https://membership.uibfs.or.ug/uib-api/membership/cpd-events/${id}/status`,
    undefined,
    {
      ...options,
      params: { ...params, ...options?.params },
    },
  );
};

export const getChangeEventStatusMutationOptions = <
  TError = AxiosError<ErrorResponse | ErrorResponse | ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof changeEventStatus>>,
    TError,
    { id: number; params: ChangeEventStatusParams },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof changeEventStatus>>,
  TError,
  { id: number; params: ChangeEventStatusParams },
  TContext
> => {
  const mutationKey = ["changeEventStatus"];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof changeEventStatus>>,
    { id: number; params: ChangeEventStatusParams }
  > = (props) => {
    const { id, params } = props ?? {};

    return changeEventStatus(id, params, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ChangeEventStatusMutationResult = NonNullable<
  Awaited<ReturnType<typeof changeEventStatus>>
>;

export type ChangeEventStatusMutationError = AxiosError<
  ErrorResponse | ErrorResponse | ErrorResponse
>;

/**
 * @summary Change event status
 */
export const useChangeEventStatus = <
  TError = AxiosError<ErrorResponse | ErrorResponse | ErrorResponse>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof changeEventStatus>>,
      TError,
      { id: number; params: ChangeEventStatusParams },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof changeEventStatus>>,
  TError,
  { id: number; params: ChangeEventStatusParams },
  TContext
> => {
  const mutationOptions = getChangeEventStatusMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Updates the status of an application.
 * @summary Change application status
 */
export const changeApplicationStatus = (
  id: number,
  params: ChangeApplicationStatusParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<ApiResponse>> => {
  return axios.default.patch(
    `https://membership.uibfs.or.ug/uib-api/membership/application/${id}/status`,
    undefined,
    {
      ...options,
      params: { ...params, ...options?.params },
    },
  );
};

export const getChangeApplicationStatusMutationOptions = <
  TError = AxiosError<ApiResponse | ApiResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof changeApplicationStatus>>,
    TError,
    { id: number; params: ChangeApplicationStatusParams },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof changeApplicationStatus>>,
  TError,
  { id: number; params: ChangeApplicationStatusParams },
  TContext
> => {
  const mutationKey = ["changeApplicationStatus"];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof changeApplicationStatus>>,
    { id: number; params: ChangeApplicationStatusParams }
  > = (props) => {
    const { id, params } = props ?? {};

    return changeApplicationStatus(id, params, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ChangeApplicationStatusMutationResult = NonNullable<
  Awaited<ReturnType<typeof changeApplicationStatus>>
>;

export type ChangeApplicationStatusMutationError = AxiosError<
  ApiResponse | ApiResponse
>;

/**
 * @summary Change application status
 */
export const useChangeApplicationStatus = <
  TError = AxiosError<ApiResponse | ApiResponse>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof changeApplicationStatus>>,
      TError,
      { id: number; params: ChangeApplicationStatusParams },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof changeApplicationStatus>>,
  TError,
  { id: number; params: ChangeApplicationStatusParams },
  TContext
> => {
  const mutationOptions = getChangeApplicationStatusMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

export const searchOrList = (
  params?: SearchOrListParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<PageTrainingNeedResponseDTO>> => {
  return axios.default.get(
    `https://membership.uibfs.or.ug/uib-api/membership/training-needs`,
    {
      ...options,
      params: { ...params, ...options?.params },
    },
  );
};

export const getSearchOrListQueryKey = (params?: SearchOrListParams) => {
  return [
    `https://membership.uibfs.or.ug/uib-api/membership/training-needs`,
    ...(params ? [params] : []),
  ] as const;
};

export const getSearchOrListQueryOptions = <
  TData = Awaited<ReturnType<typeof searchOrList>>,
  TError = AxiosError<unknown>,
>(
  params?: SearchOrListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof searchOrList>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getSearchOrListQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof searchOrList>>> = ({
    signal,
  }) => searchOrList(params, { signal, ...axiosOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof searchOrList>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type SearchOrListQueryResult = NonNullable<
  Awaited<ReturnType<typeof searchOrList>>
>;
export type SearchOrListQueryError = AxiosError<unknown>;

export function useSearchOrList<
  TData = Awaited<ReturnType<typeof searchOrList>>,
  TError = AxiosError<unknown>,
>(
  params: undefined | SearchOrListParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof searchOrList>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof searchOrList>>,
          TError,
          Awaited<ReturnType<typeof searchOrList>>
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useSearchOrList<
  TData = Awaited<ReturnType<typeof searchOrList>>,
  TError = AxiosError<unknown>,
>(
  params?: SearchOrListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof searchOrList>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof searchOrList>>,
          TError,
          Awaited<ReturnType<typeof searchOrList>>
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useSearchOrList<
  TData = Awaited<ReturnType<typeof searchOrList>>,
  TError = AxiosError<unknown>,
>(
  params?: SearchOrListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof searchOrList>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useSearchOrList<
  TData = Awaited<ReturnType<typeof searchOrList>>,
  TError = AxiosError<unknown>,
>(
  params?: SearchOrListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof searchOrList>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getSearchOrListQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const exportReport = (
  reportId: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<ExportReport200>> => {
  return axios.default.get(
    `https://membership.uibfs.or.ug/uib-api/membership/test/reports/${reportId}/export`,
    options,
  );
};

export const getExportReportQueryKey = (reportId?: string) => {
  return [
    `https://membership.uibfs.or.ug/uib-api/membership/test/reports/${reportId}/export`,
  ] as const;
};

export const getExportReportQueryOptions = <
  TData = Awaited<ReturnType<typeof exportReport>>,
  TError = AxiosError<unknown>,
>(
  reportId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof exportReport>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getExportReportQueryKey(reportId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof exportReport>>> = ({
    signal,
  }) => exportReport(reportId, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!reportId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof exportReport>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ExportReportQueryResult = NonNullable<
  Awaited<ReturnType<typeof exportReport>>
>;
export type ExportReportQueryError = AxiosError<unknown>;

export function useExportReport<
  TData = Awaited<ReturnType<typeof exportReport>>,
  TError = AxiosError<unknown>,
>(
  reportId: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof exportReport>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof exportReport>>,
          TError,
          Awaited<ReturnType<typeof exportReport>>
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useExportReport<
  TData = Awaited<ReturnType<typeof exportReport>>,
  TError = AxiosError<unknown>,
>(
  reportId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof exportReport>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof exportReport>>,
          TError,
          Awaited<ReturnType<typeof exportReport>>
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useExportReport<
  TData = Awaited<ReturnType<typeof exportReport>>,
  TError = AxiosError<unknown>,
>(
  reportId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof exportReport>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useExportReport<
  TData = Awaited<ReturnType<typeof exportReport>>,
  TError = AxiosError<unknown>,
>(
  reportId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof exportReport>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getExportReportQueryOptions(reportId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const ping = (
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<Ping200>> => {
  return axios.default.get(
    `https://membership.uibfs.or.ug/uib-api/membership/test/ping`,
    options,
  );
};

export const getPingQueryKey = () => {
  return [
    `https://membership.uibfs.or.ug/uib-api/membership/test/ping`,
  ] as const;
};

export const getPingQueryOptions = <
  TData = Awaited<ReturnType<typeof ping>>,
  TError = AxiosError<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof ping>>, TError, TData>
  >;
  axios?: AxiosRequestConfig;
}) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getPingQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof ping>>> = ({
    signal,
  }) => ping({ signal, ...axiosOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof ping>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type PingQueryResult = NonNullable<Awaited<ReturnType<typeof ping>>>;
export type PingQueryError = AxiosError<unknown>;

export function usePing<
  TData = Awaited<ReturnType<typeof ping>>,
  TError = AxiosError<unknown>,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof ping>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof ping>>,
          TError,
          Awaited<ReturnType<typeof ping>>
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function usePing<
  TData = Awaited<ReturnType<typeof ping>>,
  TError = AxiosError<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof ping>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof ping>>,
          TError,
          Awaited<ReturnType<typeof ping>>
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function usePing<
  TData = Awaited<ReturnType<typeof ping>>,
  TError = AxiosError<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof ping>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function usePing<
  TData = Awaited<ReturnType<typeof ping>>,
  TError = AxiosError<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof ping>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getPingQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const viewPage = (
  pageSlug: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<ViewPage200>> => {
  return axios.default.get(
    `https://membership.uibfs.or.ug/uib-api/membership/test/pages/${pageSlug}`,
    options,
  );
};

export const getViewPageQueryKey = (pageSlug?: string) => {
  return [
    `https://membership.uibfs.or.ug/uib-api/membership/test/pages/${pageSlug}`,
  ] as const;
};

export const getViewPageQueryOptions = <
  TData = Awaited<ReturnType<typeof viewPage>>,
  TError = AxiosError<unknown>,
>(
  pageSlug: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof viewPage>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getViewPageQueryKey(pageSlug);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof viewPage>>> = ({
    signal,
  }) => viewPage(pageSlug, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!pageSlug,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof viewPage>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData>;
  };
};

export type ViewPageQueryResult = NonNullable<
  Awaited<ReturnType<typeof viewPage>>
>;
export type ViewPageQueryError = AxiosError<unknown>;

export function useViewPage<
  TData = Awaited<ReturnType<typeof viewPage>>,
  TError = AxiosError<unknown>,
>(
  pageSlug: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof viewPage>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof viewPage>>,
          TError,
          Awaited<ReturnType<typeof viewPage>>
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useViewPage<
  TData = Awaited<ReturnType<typeof viewPage>>,
  TError = AxiosError<unknown>,
>(
  pageSlug: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof viewPage>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof viewPage>>,
          TError,
          Awaited<ReturnType<typeof viewPage>>
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useViewPage<
  TData = Awaited<ReturnType<typeof viewPage>>,
  TError = AxiosError<unknown>,
>(
  pageSlug: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof viewPage>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useViewPage<
  TData = Awaited<ReturnType<typeof viewPage>>,
  TError = AxiosError<unknown>,
>(
  pageSlug: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof viewPage>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getViewPageQueryOptions(pageSlug, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const viewDocument = (
  documentId: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<ViewDocument200>> => {
  return axios.default.get(
    `https://membership.uibfs.or.ug/uib-api/membership/test/documents/${documentId}`,
    options,
  );
};

export const getViewDocumentQueryKey = (documentId?: string) => {
  return [
    `https://membership.uibfs.or.ug/uib-api/membership/test/documents/${documentId}`,
  ] as const;
};

export const getViewDocumentQueryOptions = <
  TData = Awaited<ReturnType<typeof viewDocument>>,
  TError = AxiosError<unknown>,
>(
  documentId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof viewDocument>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getViewDocumentQueryKey(documentId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof viewDocument>>> = ({
    signal,
  }) => viewDocument(documentId, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!documentId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof viewDocument>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ViewDocumentQueryResult = NonNullable<
  Awaited<ReturnType<typeof viewDocument>>
>;
export type ViewDocumentQueryError = AxiosError<unknown>;

export function useViewDocument<
  TData = Awaited<ReturnType<typeof viewDocument>>,
  TError = AxiosError<unknown>,
>(
  documentId: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof viewDocument>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof viewDocument>>,
          TError,
          Awaited<ReturnType<typeof viewDocument>>
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useViewDocument<
  TData = Awaited<ReturnType<typeof viewDocument>>,
  TError = AxiosError<unknown>,
>(
  documentId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof viewDocument>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof viewDocument>>,
          TError,
          Awaited<ReturnType<typeof viewDocument>>
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useViewDocument<
  TData = Awaited<ReturnType<typeof viewDocument>>,
  TError = AxiosError<unknown>,
>(
  documentId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof viewDocument>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useViewDocument<
  TData = Awaited<ReturnType<typeof viewDocument>>,
  TError = AxiosError<unknown>,
>(
  documentId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof viewDocument>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getViewDocumentQueryOptions(documentId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getAllRequirements = (
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<RequirementDto[]>> => {
  return axios.default.get(
    `https://membership.uibfs.or.ug/uib-api/membership/requirements`,
    options,
  );
};

export const getGetAllRequirementsQueryKey = () => {
  return [
    `https://membership.uibfs.or.ug/uib-api/membership/requirements`,
  ] as const;
};

export const getGetAllRequirementsQueryOptions = <
  TData = Awaited<ReturnType<typeof getAllRequirements>>,
  TError = AxiosError<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getAllRequirements>>,
      TError,
      TData
    >
  >;
  axios?: AxiosRequestConfig;
}) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetAllRequirementsQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getAllRequirements>>
  > = ({ signal }) => getAllRequirements({ signal, ...axiosOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getAllRequirements>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetAllRequirementsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAllRequirements>>
>;
export type GetAllRequirementsQueryError = AxiosError<unknown>;

export function useGetAllRequirements<
  TData = Awaited<ReturnType<typeof getAllRequirements>>,
  TError = AxiosError<unknown>,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAllRequirements>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllRequirements>>,
          TError,
          Awaited<ReturnType<typeof getAllRequirements>>
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetAllRequirements<
  TData = Awaited<ReturnType<typeof getAllRequirements>>,
  TError = AxiosError<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAllRequirements>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllRequirements>>,
          TError,
          Awaited<ReturnType<typeof getAllRequirements>>
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetAllRequirements<
  TData = Awaited<ReturnType<typeof getAllRequirements>>,
  TError = AxiosError<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAllRequirements>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetAllRequirements<
  TData = Awaited<ReturnType<typeof getAllRequirements>>,
  TError = AxiosError<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAllRequirements>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetAllRequirementsQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Returns aggregated training needs for members within a date range, grouped by identified skill gaps.
 * @summary Training needs overview
 */
export const getTrainingNeeds = (
  params: GetTrainingNeedsParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<TrainingNeedsReport[]>> => {
  return axios.default.get(
    `https://membership.uibfs.or.ug/uib-api/membership/reports/training-needs`,
    {
      ...options,
      params: { ...params, ...options?.params },
    },
  );
};

export const getGetTrainingNeedsQueryKey = (
  params?: GetTrainingNeedsParams,
) => {
  return [
    `https://membership.uibfs.or.ug/uib-api/membership/reports/training-needs`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetTrainingNeedsQueryOptions = <
  TData = Awaited<ReturnType<typeof getTrainingNeeds>>,
  TError = AxiosError<TrainingNeedsReport[] | TrainingNeedsReport[]>,
>(
  params: GetTrainingNeedsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTrainingNeeds>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetTrainingNeedsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getTrainingNeeds>>
  > = ({ signal }) => getTrainingNeeds(params, { signal, ...axiosOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getTrainingNeeds>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetTrainingNeedsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getTrainingNeeds>>
>;
export type GetTrainingNeedsQueryError = AxiosError<
  TrainingNeedsReport[] | TrainingNeedsReport[]
>;

export function useGetTrainingNeeds<
  TData = Awaited<ReturnType<typeof getTrainingNeeds>>,
  TError = AxiosError<TrainingNeedsReport[] | TrainingNeedsReport[]>,
>(
  params: GetTrainingNeedsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTrainingNeeds>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTrainingNeeds>>,
          TError,
          Awaited<ReturnType<typeof getTrainingNeeds>>
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetTrainingNeeds<
  TData = Awaited<ReturnType<typeof getTrainingNeeds>>,
  TError = AxiosError<TrainingNeedsReport[] | TrainingNeedsReport[]>,
>(
  params: GetTrainingNeedsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTrainingNeeds>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTrainingNeeds>>,
          TError,
          Awaited<ReturnType<typeof getTrainingNeeds>>
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetTrainingNeeds<
  TData = Awaited<ReturnType<typeof getTrainingNeeds>>,
  TError = AxiosError<TrainingNeedsReport[] | TrainingNeedsReport[]>,
>(
  params: GetTrainingNeedsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTrainingNeeds>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Training needs overview
 */

export function useGetTrainingNeeds<
  TData = Awaited<ReturnType<typeof getTrainingNeeds>>,
  TError = AxiosError<TrainingNeedsReport[] | TrainingNeedsReport[]>,
>(
  params: GetTrainingNeedsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTrainingNeeds>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetTrainingNeedsQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Provides registration counts for the supplied period, now including per-period membershipCategoryBreakdown (registrationsByCategory) details for stacked visualisations.
 * @summary Member registration statistics
 */
export const registrations = (
  params: RegistrationsParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<RegistrationStats[]>> => {
  return axios.default.get(
    `https://membership.uibfs.or.ug/uib-api/membership/reports/registrations`,
    {
      ...options,
      params: { ...params, ...options?.params },
    },
  );
};

export const getRegistrationsQueryKey = (params?: RegistrationsParams) => {
  return [
    `https://membership.uibfs.or.ug/uib-api/membership/reports/registrations`,
    ...(params ? [params] : []),
  ] as const;
};

export const getRegistrationsQueryOptions = <
  TData = Awaited<ReturnType<typeof registrations>>,
  TError = AxiosError<RegistrationStats[] | RegistrationStats[]>,
>(
  params: RegistrationsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof registrations>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getRegistrationsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof registrations>>> = ({
    signal,
  }) => registrations(params, { signal, ...axiosOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof registrations>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type RegistrationsQueryResult = NonNullable<
  Awaited<ReturnType<typeof registrations>>
>;
export type RegistrationsQueryError = AxiosError<
  RegistrationStats[] | RegistrationStats[]
>;

export function useRegistrations<
  TData = Awaited<ReturnType<typeof registrations>>,
  TError = AxiosError<RegistrationStats[] | RegistrationStats[]>,
>(
  params: RegistrationsParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof registrations>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof registrations>>,
          TError,
          Awaited<ReturnType<typeof registrations>>
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useRegistrations<
  TData = Awaited<ReturnType<typeof registrations>>,
  TError = AxiosError<RegistrationStats[] | RegistrationStats[]>,
>(
  params: RegistrationsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof registrations>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof registrations>>,
          TError,
          Awaited<ReturnType<typeof registrations>>
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useRegistrations<
  TData = Awaited<ReturnType<typeof registrations>>,
  TError = AxiosError<RegistrationStats[] | RegistrationStats[]>,
>(
  params: RegistrationsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof registrations>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Member registration statistics
 */

export function useRegistrations<
  TData = Awaited<ReturnType<typeof registrations>>,
  TError = AxiosError<RegistrationStats[] | RegistrationStats[]>,
>(
  params: RegistrationsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof registrations>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getRegistrationsQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Summarises income, dues, and outstanding balances for the membership portfolio within the requested period, enriched with membershipCategoryBreakdown totals and an optional institution scope filter.
 * @summary Financial performance overview
 */
export const finance = (
  params: FinanceParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<FinancialReport[]>> => {
  return axios.default.get(
    `https://membership.uibfs.or.ug/uib-api/membership/reports/finance`,
    {
      ...options,
      params: { ...params, ...options?.params },
    },
  );
};

export const getFinanceQueryKey = (params?: FinanceParams) => {
  return [
    `https://membership.uibfs.or.ug/uib-api/membership/reports/finance`,
    ...(params ? [params] : []),
  ] as const;
};

export const getFinanceQueryOptions = <
  TData = Awaited<ReturnType<typeof finance>>,
  TError = AxiosError<FinancialReport[] | FinancialReport[]>,
>(
  params: FinanceParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof finance>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getFinanceQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof finance>>> = ({
    signal,
  }) => finance(params, { signal, ...axiosOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof finance>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type FinanceQueryResult = NonNullable<
  Awaited<ReturnType<typeof finance>>
>;
export type FinanceQueryError = AxiosError<
  FinancialReport[] | FinancialReport[]
>;

export function useFinance<
  TData = Awaited<ReturnType<typeof finance>>,
  TError = AxiosError<FinancialReport[] | FinancialReport[]>,
>(
  params: FinanceParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof finance>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof finance>>,
          TError,
          Awaited<ReturnType<typeof finance>>
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useFinance<
  TData = Awaited<ReturnType<typeof finance>>,
  TError = AxiosError<FinancialReport[] | FinancialReport[]>,
>(
  params: FinanceParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof finance>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof finance>>,
          TError,
          Awaited<ReturnType<typeof finance>>
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useFinance<
  TData = Awaited<ReturnType<typeof finance>>,
  TError = AxiosError<FinancialReport[] | FinancialReport[]>,
>(
  params: FinanceParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof finance>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Financial performance overview
 */

export function useFinance<
  TData = Awaited<ReturnType<typeof finance>>,
  TError = AxiosError<FinancialReport[] | FinancialReport[]>,
>(
  params: FinanceParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof finance>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getFinanceQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Returns aggregated membership counts grouped by configured age bands.
 * @summary Member demographics by age band
 */
export const demographicsAge = (
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<DemographicsSlice[]>> => {
  return axios.default.get(
    `https://membership.uibfs.or.ug/uib-api/membership/reports/demographics/age`,
    options,
  );
};

export const getDemographicsAgeQueryKey = () => {
  return [
    `https://membership.uibfs.or.ug/uib-api/membership/reports/demographics/age`,
  ] as const;
};

export const getDemographicsAgeQueryOptions = <
  TData = Awaited<ReturnType<typeof demographicsAge>>,
  TError = AxiosError<DemographicsSlice[]>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof demographicsAge>>, TError, TData>
  >;
  axios?: AxiosRequestConfig;
}) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getDemographicsAgeQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof demographicsAge>>> = ({
    signal,
  }) => demographicsAge({ signal, ...axiosOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof demographicsAge>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type DemographicsAgeQueryResult = NonNullable<
  Awaited<ReturnType<typeof demographicsAge>>
>;
export type DemographicsAgeQueryError = AxiosError<DemographicsSlice[]>;

export function useDemographicsAge<
  TData = Awaited<ReturnType<typeof demographicsAge>>,
  TError = AxiosError<DemographicsSlice[]>,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof demographicsAge>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof demographicsAge>>,
          TError,
          Awaited<ReturnType<typeof demographicsAge>>
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useDemographicsAge<
  TData = Awaited<ReturnType<typeof demographicsAge>>,
  TError = AxiosError<DemographicsSlice[]>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof demographicsAge>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof demographicsAge>>,
          TError,
          Awaited<ReturnType<typeof demographicsAge>>
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useDemographicsAge<
  TData = Awaited<ReturnType<typeof demographicsAge>>,
  TError = AxiosError<DemographicsSlice[]>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof demographicsAge>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Member demographics by age band
 */

export function useDemographicsAge<
  TData = Awaited<ReturnType<typeof demographicsAge>>,
  TError = AxiosError<DemographicsSlice[]>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof demographicsAge>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getDemographicsAgeQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Returns the user's notifications alongside the current unread count.
 * @summary Get notifications for a user
 */
export const getUserNotifications = (
  userId: number,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<InternalNotificationFeedResponse>> => {
  return axios.default.get(
    `https://membership.uibfs.or.ug/uib-api/membership/notifications/user/${userId}`,
    options,
  );
};

export const getGetUserNotificationsQueryKey = (userId?: number) => {
  return [
    `https://membership.uibfs.or.ug/uib-api/membership/notifications/user/${userId}`,
  ] as const;
};

export const getGetUserNotificationsQueryOptions = <
  TData = Awaited<ReturnType<typeof getUserNotifications>>,
  TError = AxiosError<InternalNotificationFeedResponse>,
>(
  userId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUserNotifications>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetUserNotificationsQueryKey(userId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getUserNotifications>>
  > = ({ signal }) => getUserNotifications(userId, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!userId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getUserNotifications>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetUserNotificationsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getUserNotifications>>
>;
export type GetUserNotificationsQueryError =
  AxiosError<InternalNotificationFeedResponse>;

export function useGetUserNotifications<
  TData = Awaited<ReturnType<typeof getUserNotifications>>,
  TError = AxiosError<InternalNotificationFeedResponse>,
>(
  userId: number,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUserNotifications>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserNotifications>>,
          TError,
          Awaited<ReturnType<typeof getUserNotifications>>
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetUserNotifications<
  TData = Awaited<ReturnType<typeof getUserNotifications>>,
  TError = AxiosError<InternalNotificationFeedResponse>,
>(
  userId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUserNotifications>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserNotifications>>,
          TError,
          Awaited<ReturnType<typeof getUserNotifications>>
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetUserNotifications<
  TData = Awaited<ReturnType<typeof getUserNotifications>>,
  TError = AxiosError<InternalNotificationFeedResponse>,
>(
  userId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUserNotifications>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get notifications for a user
 */

export function useGetUserNotifications<
  TData = Awaited<ReturnType<typeof getUserNotifications>>,
  TError = AxiosError<InternalNotificationFeedResponse>,
>(
  userId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUserNotifications>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetUserNotificationsQueryOptions(userId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Fetch a single programme's details using its unique identifier.
 * @summary Retrieve programme by id
 */
export const getCPDProgramById = (
  id: number,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<ProgramDTO>> => {
  return axios.default.get(
    `https://membership.uibfs.or.ug/uib-api/membership/get-cpd-program/${id}`,
    options,
  );
};

export const getGetCPDProgramByIdQueryKey = (id?: number) => {
  return [
    `https://membership.uibfs.or.ug/uib-api/membership/get-cpd-program/${id}`,
  ] as const;
};

export const getGetCPDProgramByIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getCPDProgramById>>,
  TError = AxiosError<ProgramDTO>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCPDProgramById>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetCPDProgramByIdQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getCPDProgramById>>
  > = ({ signal }) => getCPDProgramById(id, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getCPDProgramById>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetCPDProgramByIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getCPDProgramById>>
>;
export type GetCPDProgramByIdQueryError = AxiosError<ProgramDTO>;

export function useGetCPDProgramById<
  TData = Awaited<ReturnType<typeof getCPDProgramById>>,
  TError = AxiosError<ProgramDTO>,
>(
  id: number,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCPDProgramById>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCPDProgramById>>,
          TError,
          Awaited<ReturnType<typeof getCPDProgramById>>
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetCPDProgramById<
  TData = Awaited<ReturnType<typeof getCPDProgramById>>,
  TError = AxiosError<ProgramDTO>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCPDProgramById>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCPDProgramById>>,
          TError,
          Awaited<ReturnType<typeof getCPDProgramById>>
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetCPDProgramById<
  TData = Awaited<ReturnType<typeof getCPDProgramById>>,
  TError = AxiosError<ProgramDTO>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCPDProgramById>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Retrieve programme by id
 */

export function useGetCPDProgramById<
  TData = Awaited<ReturnType<typeof getCPDProgramById>>,
  TError = AxiosError<ProgramDTO>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCPDProgramById>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetCPDProgramByIdQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Retrieve a paginated list of past CPD resources filtered by publication status.
 * @summary List past CPD resources
 */
export const listAllPastResource = (
  params?: ListAllPastResourceParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<RestPagePastCpdResource>> => {
  return axios.default.get(
    `https://membership.uibfs.or.ug/uib-api/membership/cpd/past-resources`,
    {
      ...options,
      params: { ...params, ...options?.params },
    },
  );
};

export const getListAllPastResourceQueryKey = (
  params?: ListAllPastResourceParams,
) => {
  return [
    `https://membership.uibfs.or.ug/uib-api/membership/cpd/past-resources`,
    ...(params ? [params] : []),
  ] as const;
};

export const getListAllPastResourceQueryOptions = <
  TData = Awaited<ReturnType<typeof listAllPastResource>>,
  TError = AxiosError<ApiResponse | ApiResponse>,
>(
  params?: ListAllPastResourceParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listAllPastResource>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListAllPastResourceQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listAllPastResource>>
  > = ({ signal }) => listAllPastResource(params, { signal, ...axiosOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listAllPastResource>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ListAllPastResourceQueryResult = NonNullable<
  Awaited<ReturnType<typeof listAllPastResource>>
>;
export type ListAllPastResourceQueryError = AxiosError<
  ApiResponse | ApiResponse
>;

export function useListAllPastResource<
  TData = Awaited<ReturnType<typeof listAllPastResource>>,
  TError = AxiosError<ApiResponse | ApiResponse>,
>(
  params: undefined | ListAllPastResourceParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listAllPastResource>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAllPastResource>>,
          TError,
          Awaited<ReturnType<typeof listAllPastResource>>
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useListAllPastResource<
  TData = Awaited<ReturnType<typeof listAllPastResource>>,
  TError = AxiosError<ApiResponse | ApiResponse>,
>(
  params?: ListAllPastResourceParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listAllPastResource>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAllPastResource>>,
          TError,
          Awaited<ReturnType<typeof listAllPastResource>>
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListAllPastResource<
  TData = Awaited<ReturnType<typeof listAllPastResource>>,
  TError = AxiosError<ApiResponse | ApiResponse>,
>(
  params?: ListAllPastResourceParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listAllPastResource>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List past CPD resources
 */

export function useListAllPastResource<
  TData = Awaited<ReturnType<typeof listAllPastResource>>,
  TError = AxiosError<ApiResponse | ApiResponse>,
>(
  params?: ListAllPastResourceParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listAllPastResource>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getListAllPastResourceQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Returns every programme configured in the membership catalogue.
 * @summary List all membership programmes
 */
export const getAllCPDPrograms = (
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<ProgramDTO[]>> => {
  return axios.default.get(
    `https://membership.uibfs.or.ug/uib-api/membership/cpd-programs`,
    options,
  );
};

export const getGetAllCPDProgramsQueryKey = () => {
  return [
    `https://membership.uibfs.or.ug/uib-api/membership/cpd-programs`,
  ] as const;
};

export const getGetAllCPDProgramsQueryOptions = <
  TData = Awaited<ReturnType<typeof getAllCPDPrograms>>,
  TError = AxiosError<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getAllCPDPrograms>>,
      TError,
      TData
    >
  >;
  axios?: AxiosRequestConfig;
}) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetAllCPDProgramsQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getAllCPDPrograms>>
  > = ({ signal }) => getAllCPDPrograms({ signal, ...axiosOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getAllCPDPrograms>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetAllCPDProgramsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAllCPDPrograms>>
>;
export type GetAllCPDProgramsQueryError = AxiosError<unknown>;

export function useGetAllCPDPrograms<
  TData = Awaited<ReturnType<typeof getAllCPDPrograms>>,
  TError = AxiosError<unknown>,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAllCPDPrograms>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllCPDPrograms>>,
          TError,
          Awaited<ReturnType<typeof getAllCPDPrograms>>
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetAllCPDPrograms<
  TData = Awaited<ReturnType<typeof getAllCPDPrograms>>,
  TError = AxiosError<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAllCPDPrograms>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllCPDPrograms>>,
          TError,
          Awaited<ReturnType<typeof getAllCPDPrograms>>
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetAllCPDPrograms<
  TData = Awaited<ReturnType<typeof getAllCPDPrograms>>,
  TError = AxiosError<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAllCPDPrograms>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List all membership programmes
 */

export function useGetAllCPDPrograms<
  TData = Awaited<ReturnType<typeof getAllCPDPrograms>>,
  TError = AxiosError<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAllCPDPrograms>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetAllCPDProgramsQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Retrieve paginated CPD points awards for a member
 * @summary Get awards by member
 */
export const getAwardsByMember = (
  memberId: string,
  params?: GetAwardsByMemberParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<RestPageCPDPointsAward>> => {
  return axios.default.get(
    `https://membership.uibfs.or.ug/uib-api/membership/cpd-points/members/${memberId}/awards`,
    {
      ...options,
      params: { ...params, ...options?.params },
    },
  );
};

export const getGetAwardsByMemberQueryKey = (
  memberId?: string,
  params?: GetAwardsByMemberParams,
) => {
  return [
    `https://membership.uibfs.or.ug/uib-api/membership/cpd-points/members/${memberId}/awards`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetAwardsByMemberQueryOptions = <
  TData = Awaited<ReturnType<typeof getAwardsByMember>>,
  TError = AxiosError<
    ErrorResponse | PaginatedResponseCPDPointsAwardResponseDTO | ErrorResponse
  >,
>(
  memberId: string,
  params?: GetAwardsByMemberParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAwardsByMember>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetAwardsByMemberQueryKey(memberId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getAwardsByMember>>
  > = ({ signal }) =>
    getAwardsByMember(memberId, params, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!memberId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getAwardsByMember>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetAwardsByMemberQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAwardsByMember>>
>;
export type GetAwardsByMemberQueryError = AxiosError<
  ErrorResponse | PaginatedResponseCPDPointsAwardResponseDTO | ErrorResponse
>;

export function useGetAwardsByMember<
  TData = Awaited<ReturnType<typeof getAwardsByMember>>,
  TError = AxiosError<
    ErrorResponse | PaginatedResponseCPDPointsAwardResponseDTO | ErrorResponse
  >,
>(
  memberId: string,
  params: undefined | GetAwardsByMemberParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAwardsByMember>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAwardsByMember>>,
          TError,
          Awaited<ReturnType<typeof getAwardsByMember>>
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetAwardsByMember<
  TData = Awaited<ReturnType<typeof getAwardsByMember>>,
  TError = AxiosError<
    ErrorResponse | PaginatedResponseCPDPointsAwardResponseDTO | ErrorResponse
  >,
>(
  memberId: string,
  params?: GetAwardsByMemberParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAwardsByMember>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAwardsByMember>>,
          TError,
          Awaited<ReturnType<typeof getAwardsByMember>>
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetAwardsByMember<
  TData = Awaited<ReturnType<typeof getAwardsByMember>>,
  TError = AxiosError<
    ErrorResponse | PaginatedResponseCPDPointsAwardResponseDTO | ErrorResponse
  >,
>(
  memberId: string,
  params?: GetAwardsByMemberParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAwardsByMember>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get awards by member
 */

export function useGetAwardsByMember<
  TData = Awaited<ReturnType<typeof getAwardsByMember>>,
  TError = AxiosError<
    ErrorResponse | PaginatedResponseCPDPointsAwardResponseDTO | ErrorResponse
  >,
>(
  memberId: string,
  params?: GetAwardsByMemberParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAwardsByMember>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetAwardsByMemberQueryOptions(
    memberId,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Retrieve paginated CPD points awards for an event
 * @summary Get awards by event
 */
export const getAwardsByEvent = (
  eventId: number,
  params?: GetAwardsByEventParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<RestPageCPDPointsAward>> => {
  return axios.default.get(
    `https://membership.uibfs.or.ug/uib-api/membership/cpd-points/events/${eventId}/awards`,
    {
      ...options,
      params: { ...params, ...options?.params },
    },
  );
};

export const getGetAwardsByEventQueryKey = (
  eventId?: number,
  params?: GetAwardsByEventParams,
) => {
  return [
    `https://membership.uibfs.or.ug/uib-api/membership/cpd-points/events/${eventId}/awards`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetAwardsByEventQueryOptions = <
  TData = Awaited<ReturnType<typeof getAwardsByEvent>>,
  TError = AxiosError<
    ErrorResponse | PaginatedResponseCPDPointsAwardResponseDTO | ErrorResponse
  >,
>(
  eventId: number,
  params?: GetAwardsByEventParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAwardsByEvent>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetAwardsByEventQueryKey(eventId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getAwardsByEvent>>
  > = ({ signal }) =>
    getAwardsByEvent(eventId, params, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!eventId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getAwardsByEvent>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetAwardsByEventQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAwardsByEvent>>
>;
export type GetAwardsByEventQueryError = AxiosError<
  ErrorResponse | PaginatedResponseCPDPointsAwardResponseDTO | ErrorResponse
>;

export function useGetAwardsByEvent<
  TData = Awaited<ReturnType<typeof getAwardsByEvent>>,
  TError = AxiosError<
    ErrorResponse | PaginatedResponseCPDPointsAwardResponseDTO | ErrorResponse
  >,
>(
  eventId: number,
  params: undefined | GetAwardsByEventParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAwardsByEvent>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAwardsByEvent>>,
          TError,
          Awaited<ReturnType<typeof getAwardsByEvent>>
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetAwardsByEvent<
  TData = Awaited<ReturnType<typeof getAwardsByEvent>>,
  TError = AxiosError<
    ErrorResponse | PaginatedResponseCPDPointsAwardResponseDTO | ErrorResponse
  >,
>(
  eventId: number,
  params?: GetAwardsByEventParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAwardsByEvent>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAwardsByEvent>>,
          TError,
          Awaited<ReturnType<typeof getAwardsByEvent>>
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetAwardsByEvent<
  TData = Awaited<ReturnType<typeof getAwardsByEvent>>,
  TError = AxiosError<
    ErrorResponse | PaginatedResponseCPDPointsAwardResponseDTO | ErrorResponse
  >,
>(
  eventId: number,
  params?: GetAwardsByEventParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAwardsByEvent>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get awards by event
 */

export function useGetAwardsByEvent<
  TData = Awaited<ReturnType<typeof getAwardsByEvent>>,
  TError = AxiosError<
    ErrorResponse | PaginatedResponseCPDPointsAwardResponseDTO | ErrorResponse
  >,
>(
  eventId: number,
  params?: GetAwardsByEventParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAwardsByEvent>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetAwardsByEventQueryOptions(
    eventId,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Retrieve participants for a specific event
 * @summary Get event participants
 */
export const getEventParticipants = (
  eventId: number,
  params?: GetEventParticipantsParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<RestPageCPDParticipant>> => {
  return axios.default.get(
    `https://membership.uibfs.or.ug/uib-api/membership/cpd-events/${eventId}/participants`,
    {
      ...options,
      params: { ...params, ...options?.params },
    },
  );
};

export const getGetEventParticipantsQueryKey = (
  eventId?: number,
  params?: GetEventParticipantsParams,
) => {
  return [
    `https://membership.uibfs.or.ug/uib-api/membership/cpd-events/${eventId}/participants`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetEventParticipantsQueryOptions = <
  TData = Awaited<ReturnType<typeof getEventParticipants>>,
  TError = AxiosError<ErrorResponse | ErrorResponse>,
>(
  eventId: number,
  params?: GetEventParticipantsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getEventParticipants>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetEventParticipantsQueryKey(eventId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getEventParticipants>>
  > = ({ signal }) =>
    getEventParticipants(eventId, params, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!eventId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getEventParticipants>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetEventParticipantsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getEventParticipants>>
>;
export type GetEventParticipantsQueryError = AxiosError<
  ErrorResponse | ErrorResponse
>;

export function useGetEventParticipants<
  TData = Awaited<ReturnType<typeof getEventParticipants>>,
  TError = AxiosError<ErrorResponse | ErrorResponse>,
>(
  eventId: number,
  params: undefined | GetEventParticipantsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getEventParticipants>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEventParticipants>>,
          TError,
          Awaited<ReturnType<typeof getEventParticipants>>
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetEventParticipants<
  TData = Awaited<ReturnType<typeof getEventParticipants>>,
  TError = AxiosError<ErrorResponse | ErrorResponse>,
>(
  eventId: number,
  params?: GetEventParticipantsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getEventParticipants>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEventParticipants>>,
          TError,
          Awaited<ReturnType<typeof getEventParticipants>>
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetEventParticipants<
  TData = Awaited<ReturnType<typeof getEventParticipants>>,
  TError = AxiosError<ErrorResponse | ErrorResponse>,
>(
  eventId: number,
  params?: GetEventParticipantsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getEventParticipants>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get event participants
 */

export function useGetEventParticipants<
  TData = Awaited<ReturnType<typeof getEventParticipants>>,
  TError = AxiosError<ErrorResponse | ErrorResponse>,
>(
  eventId: number,
  params?: GetEventParticipantsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getEventParticipants>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetEventParticipantsQueryOptions(
    eventId,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Retrieve total CPD points for a user
 * @summary Get user CPD points
 */
export const getUserCPDPoints = (
  userId: number,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<number>> => {
  return axios.default.get(
    `https://membership.uibfs.or.ug/uib-api/membership/cpd-events/users/${userId}/cpd-points`,
    options,
  );
};

export const getGetUserCPDPointsQueryKey = (userId?: number) => {
  return [
    `https://membership.uibfs.or.ug/uib-api/membership/cpd-events/users/${userId}/cpd-points`,
  ] as const;
};

export const getGetUserCPDPointsQueryOptions = <
  TData = Awaited<ReturnType<typeof getUserCPDPoints>>,
  TError = AxiosError<number | number>,
>(
  userId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUserCPDPoints>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetUserCPDPointsQueryKey(userId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getUserCPDPoints>>
  > = ({ signal }) => getUserCPDPoints(userId, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!userId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getUserCPDPoints>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetUserCPDPointsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getUserCPDPoints>>
>;
export type GetUserCPDPointsQueryError = AxiosError<number | number>;

export function useGetUserCPDPoints<
  TData = Awaited<ReturnType<typeof getUserCPDPoints>>,
  TError = AxiosError<number | number>,
>(
  userId: number,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUserCPDPoints>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserCPDPoints>>,
          TError,
          Awaited<ReturnType<typeof getUserCPDPoints>>
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetUserCPDPoints<
  TData = Awaited<ReturnType<typeof getUserCPDPoints>>,
  TError = AxiosError<number | number>,
>(
  userId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUserCPDPoints>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserCPDPoints>>,
          TError,
          Awaited<ReturnType<typeof getUserCPDPoints>>
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetUserCPDPoints<
  TData = Awaited<ReturnType<typeof getUserCPDPoints>>,
  TError = AxiosError<number | number>,
>(
  userId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUserCPDPoints>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get user CPD points
 */

export function useGetUserCPDPoints<
  TData = Awaited<ReturnType<typeof getUserCPDPoints>>,
  TError = AxiosError<number | number>,
>(
  userId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUserCPDPoints>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetUserCPDPointsQueryOptions(userId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Retrieve upcoming CPD events
 * @summary Get upcoming events
 */
export const getUpcomingEvents = (
  params?: GetUpcomingEventsParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<RestPageCPDEvent>> => {
  return axios.default.get(
    `https://membership.uibfs.or.ug/uib-api/membership/cpd-events/upcoming`,
    {
      ...options,
      params: { ...params, ...options?.params },
    },
  );
};

export const getGetUpcomingEventsQueryKey = (
  params?: GetUpcomingEventsParams,
) => {
  return [
    `https://membership.uibfs.or.ug/uib-api/membership/cpd-events/upcoming`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetUpcomingEventsQueryOptions = <
  TData = Awaited<ReturnType<typeof getUpcomingEvents>>,
  TError = AxiosError<ErrorResponse | ErrorResponse>,
>(
  params?: GetUpcomingEventsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUpcomingEvents>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetUpcomingEventsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getUpcomingEvents>>
  > = ({ signal }) => getUpcomingEvents(params, { signal, ...axiosOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getUpcomingEvents>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetUpcomingEventsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getUpcomingEvents>>
>;
export type GetUpcomingEventsQueryError = AxiosError<
  ErrorResponse | ErrorResponse
>;

export function useGetUpcomingEvents<
  TData = Awaited<ReturnType<typeof getUpcomingEvents>>,
  TError = AxiosError<ErrorResponse | ErrorResponse>,
>(
  params: undefined | GetUpcomingEventsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUpcomingEvents>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUpcomingEvents>>,
          TError,
          Awaited<ReturnType<typeof getUpcomingEvents>>
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetUpcomingEvents<
  TData = Awaited<ReturnType<typeof getUpcomingEvents>>,
  TError = AxiosError<ErrorResponse | ErrorResponse>,
>(
  params?: GetUpcomingEventsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUpcomingEvents>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUpcomingEvents>>,
          TError,
          Awaited<ReturnType<typeof getUpcomingEvents>>
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetUpcomingEvents<
  TData = Awaited<ReturnType<typeof getUpcomingEvents>>,
  TError = AxiosError<ErrorResponse | ErrorResponse>,
>(
  params?: GetUpcomingEventsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUpcomingEvents>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get upcoming events
 */

export function useGetUpcomingEvents<
  TData = Awaited<ReturnType<typeof getUpcomingEvents>>,
  TError = AxiosError<ErrorResponse | ErrorResponse>,
>(
  params?: GetUpcomingEventsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUpcomingEvents>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetUpcomingEventsQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Retrieve CPD events filtered by status
 * @summary Get events by status
 */
export const getEventsByStatus = (
  status:
    | "Scheduled"
    | "Ongoing"
    | "Completed"
    | "Cancelled"
    | "Draft"
    | "Registration Closed"
    | "Full",
  params?: GetEventsByStatusParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<RestPageCPDEvent>> => {
  return axios.default.get(
    `https://membership.uibfs.or.ug/uib-api/membership/cpd-events/status/${status}`,
    {
      ...options,
      params: { ...params, ...options?.params },
    },
  );
};

export const getGetEventsByStatusQueryKey = (
  status?:
    | "Scheduled"
    | "Ongoing"
    | "Completed"
    | "Cancelled"
    | "Draft"
    | "Registration Closed"
    | "Full",
  params?: GetEventsByStatusParams,
) => {
  return [
    `https://membership.uibfs.or.ug/uib-api/membership/cpd-events/status/${status}`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetEventsByStatusQueryOptions = <
  TData = Awaited<ReturnType<typeof getEventsByStatus>>,
  TError = AxiosError<ErrorResponse | ErrorResponse>,
>(
  status:
    | "Scheduled"
    | "Ongoing"
    | "Completed"
    | "Cancelled"
    | "Draft"
    | "Registration Closed"
    | "Full",
  params?: GetEventsByStatusParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getEventsByStatus>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetEventsByStatusQueryKey(status, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getEventsByStatus>>
  > = ({ signal }) =>
    getEventsByStatus(status, params, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!status,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getEventsByStatus>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetEventsByStatusQueryResult = NonNullable<
  Awaited<ReturnType<typeof getEventsByStatus>>
>;
export type GetEventsByStatusQueryError = AxiosError<
  ErrorResponse | ErrorResponse
>;

export function useGetEventsByStatus<
  TData = Awaited<ReturnType<typeof getEventsByStatus>>,
  TError = AxiosError<ErrorResponse | ErrorResponse>,
>(
  status:
    | "Scheduled"
    | "Ongoing"
    | "Completed"
    | "Cancelled"
    | "Draft"
    | "Registration Closed"
    | "Full",
  params: undefined | GetEventsByStatusParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getEventsByStatus>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEventsByStatus>>,
          TError,
          Awaited<ReturnType<typeof getEventsByStatus>>
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetEventsByStatus<
  TData = Awaited<ReturnType<typeof getEventsByStatus>>,
  TError = AxiosError<ErrorResponse | ErrorResponse>,
>(
  status:
    | "Scheduled"
    | "Ongoing"
    | "Completed"
    | "Cancelled"
    | "Draft"
    | "Registration Closed"
    | "Full",
  params?: GetEventsByStatusParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getEventsByStatus>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEventsByStatus>>,
          TError,
          Awaited<ReturnType<typeof getEventsByStatus>>
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetEventsByStatus<
  TData = Awaited<ReturnType<typeof getEventsByStatus>>,
  TError = AxiosError<ErrorResponse | ErrorResponse>,
>(
  status:
    | "Scheduled"
    | "Ongoing"
    | "Completed"
    | "Cancelled"
    | "Draft"
    | "Registration Closed"
    | "Full",
  params?: GetEventsByStatusParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getEventsByStatus>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get events by status
 */

export function useGetEventsByStatus<
  TData = Awaited<ReturnType<typeof getEventsByStatus>>,
  TError = AxiosError<ErrorResponse | ErrorResponse>,
>(
  status:
    | "Scheduled"
    | "Ongoing"
    | "Completed"
    | "Cancelled"
    | "Draft"
    | "Registration Closed"
    | "Full",
  params?: GetEventsByStatusParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getEventsByStatus>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetEventsByStatusQueryOptions(
    status,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Search CPD events by title keyword
 * @summary Search events by title
 */
export const searchEvents = (
  params: SearchEventsParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<RestPageCPDEvent>> => {
  return axios.default.get(
    `https://membership.uibfs.or.ug/uib-api/membership/cpd-events/search`,
    {
      ...options,
      params: { ...params, ...options?.params },
    },
  );
};

export const getSearchEventsQueryKey = (params?: SearchEventsParams) => {
  return [
    `https://membership.uibfs.or.ug/uib-api/membership/cpd-events/search`,
    ...(params ? [params] : []),
  ] as const;
};

export const getSearchEventsQueryOptions = <
  TData = Awaited<ReturnType<typeof searchEvents>>,
  TError = AxiosError<ErrorResponse | ErrorResponse>,
>(
  params: SearchEventsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof searchEvents>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getSearchEventsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof searchEvents>>> = ({
    signal,
  }) => searchEvents(params, { signal, ...axiosOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof searchEvents>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type SearchEventsQueryResult = NonNullable<
  Awaited<ReturnType<typeof searchEvents>>
>;
export type SearchEventsQueryError = AxiosError<ErrorResponse | ErrorResponse>;

export function useSearchEvents<
  TData = Awaited<ReturnType<typeof searchEvents>>,
  TError = AxiosError<ErrorResponse | ErrorResponse>,
>(
  params: SearchEventsParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof searchEvents>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof searchEvents>>,
          TError,
          Awaited<ReturnType<typeof searchEvents>>
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useSearchEvents<
  TData = Awaited<ReturnType<typeof searchEvents>>,
  TError = AxiosError<ErrorResponse | ErrorResponse>,
>(
  params: SearchEventsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof searchEvents>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof searchEvents>>,
          TError,
          Awaited<ReturnType<typeof searchEvents>>
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useSearchEvents<
  TData = Awaited<ReturnType<typeof searchEvents>>,
  TError = AxiosError<ErrorResponse | ErrorResponse>,
>(
  params: SearchEventsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof searchEvents>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Search events by title
 */

export function useSearchEvents<
  TData = Awaited<ReturnType<typeof searchEvents>>,
  TError = AxiosError<ErrorResponse | ErrorResponse>,
>(
  params: SearchEventsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof searchEvents>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getSearchEventsQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Retrieve past CPD events
 * @summary Get past events
 */
export const getPastEvents = (
  params?: GetPastEventsParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<RestPageCPDEvent>> => {
  return axios.default.get(
    `https://membership.uibfs.or.ug/uib-api/membership/cpd-events/past`,
    {
      ...options,
      params: { ...params, ...options?.params },
    },
  );
};

export const getGetPastEventsQueryKey = (params?: GetPastEventsParams) => {
  return [
    `https://membership.uibfs.or.ug/uib-api/membership/cpd-events/past`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetPastEventsQueryOptions = <
  TData = Awaited<ReturnType<typeof getPastEvents>>,
  TError = AxiosError<ErrorResponse | ErrorResponse>,
>(
  params?: GetPastEventsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getPastEvents>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetPastEventsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getPastEvents>>> = ({
    signal,
  }) => getPastEvents(params, { signal, ...axiosOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getPastEvents>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetPastEventsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getPastEvents>>
>;
export type GetPastEventsQueryError = AxiosError<ErrorResponse | ErrorResponse>;

export function useGetPastEvents<
  TData = Awaited<ReturnType<typeof getPastEvents>>,
  TError = AxiosError<ErrorResponse | ErrorResponse>,
>(
  params: undefined | GetPastEventsParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getPastEvents>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPastEvents>>,
          TError,
          Awaited<ReturnType<typeof getPastEvents>>
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetPastEvents<
  TData = Awaited<ReturnType<typeof getPastEvents>>,
  TError = AxiosError<ErrorResponse | ErrorResponse>,
>(
  params?: GetPastEventsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getPastEvents>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPastEvents>>,
          TError,
          Awaited<ReturnType<typeof getPastEvents>>
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetPastEvents<
  TData = Awaited<ReturnType<typeof getPastEvents>>,
  TError = AxiosError<ErrorResponse | ErrorResponse>,
>(
  params?: GetPastEventsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getPastEvents>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get past events
 */

export function useGetPastEvents<
  TData = Awaited<ReturnType<typeof getPastEvents>>,
  TError = AxiosError<ErrorResponse | ErrorResponse>,
>(
  params?: GetPastEventsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getPastEvents>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetPastEventsQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Retrieve all registrations for the current user
 * @summary Get user registrations
 */
export const getMyRegistrations = (
  params?: GetMyRegistrationsParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<RestPageCPDParticipant>> => {
  return axios.default.get(
    `https://membership.uibfs.or.ug/uib-api/membership/cpd-events/my-registrations`,
    {
      ...options,
      params: { ...params, ...options?.params },
    },
  );
};

export const getGetMyRegistrationsQueryKey = (
  params?: GetMyRegistrationsParams,
) => {
  return [
    `https://membership.uibfs.or.ug/uib-api/membership/cpd-events/my-registrations`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetMyRegistrationsQueryOptions = <
  TData = Awaited<ReturnType<typeof getMyRegistrations>>,
  TError = AxiosError<ErrorResponse | ErrorResponse>,
>(
  params?: GetMyRegistrationsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMyRegistrations>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetMyRegistrationsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getMyRegistrations>>
  > = ({ signal }) => getMyRegistrations(params, { signal, ...axiosOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getMyRegistrations>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetMyRegistrationsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMyRegistrations>>
>;
export type GetMyRegistrationsQueryError = AxiosError<
  ErrorResponse | ErrorResponse
>;

export function useGetMyRegistrations<
  TData = Awaited<ReturnType<typeof getMyRegistrations>>,
  TError = AxiosError<ErrorResponse | ErrorResponse>,
>(
  params: undefined | GetMyRegistrationsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMyRegistrations>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMyRegistrations>>,
          TError,
          Awaited<ReturnType<typeof getMyRegistrations>>
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetMyRegistrations<
  TData = Awaited<ReturnType<typeof getMyRegistrations>>,
  TError = AxiosError<ErrorResponse | ErrorResponse>,
>(
  params?: GetMyRegistrationsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMyRegistrations>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMyRegistrations>>,
          TError,
          Awaited<ReturnType<typeof getMyRegistrations>>
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetMyRegistrations<
  TData = Awaited<ReturnType<typeof getMyRegistrations>>,
  TError = AxiosError<ErrorResponse | ErrorResponse>,
>(
  params?: GetMyRegistrationsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMyRegistrations>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get user registrations
 */

export function useGetMyRegistrations<
  TData = Awaited<ReturnType<typeof getMyRegistrations>>,
  TError = AxiosError<ErrorResponse | ErrorResponse>,
>(
  params?: GetMyRegistrationsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMyRegistrations>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetMyRegistrationsQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Retrieve total CPD points for the current user
 * @summary Get my CPD points
 */
export const getMyCPDPoints = (
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<MyCPDPointsResponseDTO>> => {
  return axios.default.get(
    `https://membership.uibfs.or.ug/uib-api/membership/cpd-events/my-cpd-points`,
    options,
  );
};

export const getGetMyCPDPointsQueryKey = () => {
  return [
    `https://membership.uibfs.or.ug/uib-api/membership/cpd-events/my-cpd-points`,
  ] as const;
};

export const getGetMyCPDPointsQueryOptions = <
  TData = Awaited<ReturnType<typeof getMyCPDPoints>>,
  TError = AxiosError<ErrorResponse | ErrorResponse>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getMyCPDPoints>>, TError, TData>
  >;
  axios?: AxiosRequestConfig;
}) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMyCPDPointsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMyCPDPoints>>> = ({
    signal,
  }) => getMyCPDPoints({ signal, ...axiosOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getMyCPDPoints>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetMyCPDPointsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMyCPDPoints>>
>;
export type GetMyCPDPointsQueryError = AxiosError<
  ErrorResponse | ErrorResponse
>;

export function useGetMyCPDPoints<
  TData = Awaited<ReturnType<typeof getMyCPDPoints>>,
  TError = AxiosError<ErrorResponse | ErrorResponse>,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMyCPDPoints>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMyCPDPoints>>,
          TError,
          Awaited<ReturnType<typeof getMyCPDPoints>>
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetMyCPDPoints<
  TData = Awaited<ReturnType<typeof getMyCPDPoints>>,
  TError = AxiosError<ErrorResponse | ErrorResponse>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMyCPDPoints>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMyCPDPoints>>,
          TError,
          Awaited<ReturnType<typeof getMyCPDPoints>>
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetMyCPDPoints<
  TData = Awaited<ReturnType<typeof getMyCPDPoints>>,
  TError = AxiosError<ErrorResponse | ErrorResponse>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMyCPDPoints>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get my CPD points
 */

export function useGetMyCPDPoints<
  TData = Awaited<ReturnType<typeof getMyCPDPoints>>,
  TError = AxiosError<ErrorResponse | ErrorResponse>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMyCPDPoints>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetMyCPDPointsQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Retrieve a paginated list of all CPD events
 * @summary Get all CPD events
 */
export const getAllEvents = (
  params?: GetAllEventsParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<RestPageCPDEvent>> => {
  return axios.default.get(
    `https://membership.uibfs.or.ug/uib-api/membership/cpd-events/get-allcpds`,
    {
      ...options,
      params: { ...params, ...options?.params },
    },
  );
};

export const getGetAllEventsQueryKey = (params?: GetAllEventsParams) => {
  return [
    `https://membership.uibfs.or.ug/uib-api/membership/cpd-events/get-allcpds`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetAllEventsQueryOptions = <
  TData = Awaited<ReturnType<typeof getAllEvents>>,
  TError = AxiosError<ErrorResponse | ErrorResponse>,
>(
  params?: GetAllEventsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAllEvents>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetAllEventsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getAllEvents>>> = ({
    signal,
  }) => getAllEvents(params, { signal, ...axiosOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getAllEvents>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetAllEventsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAllEvents>>
>;
export type GetAllEventsQueryError = AxiosError<ErrorResponse | ErrorResponse>;

export function useGetAllEvents<
  TData = Awaited<ReturnType<typeof getAllEvents>>,
  TError = AxiosError<ErrorResponse | ErrorResponse>,
>(
  params: undefined | GetAllEventsParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAllEvents>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllEvents>>,
          TError,
          Awaited<ReturnType<typeof getAllEvents>>
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetAllEvents<
  TData = Awaited<ReturnType<typeof getAllEvents>>,
  TError = AxiosError<ErrorResponse | ErrorResponse>,
>(
  params?: GetAllEventsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAllEvents>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllEvents>>,
          TError,
          Awaited<ReturnType<typeof getAllEvents>>
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetAllEvents<
  TData = Awaited<ReturnType<typeof getAllEvents>>,
  TError = AxiosError<ErrorResponse | ErrorResponse>,
>(
  params?: GetAllEventsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAllEvents>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get all CPD events
 */

export function useGetAllEvents<
  TData = Awaited<ReturnType<typeof getAllEvents>>,
  TError = AxiosError<ErrorResponse | ErrorResponse>,
>(
  params?: GetAllEventsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAllEvents>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetAllEventsQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Returns the communities where the current user has joined membership.
 * @summary List communities that I belong to
 */
export const listMyCommunities = (
  params?: ListMyCommunitiesParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<PageCommunityDTO>> => {
  return axios.default.get(
    `https://membership.uibfs.or.ug/uib-api/membership/communities/my`,
    {
      ...options,
      params: { ...params, ...options?.params },
    },
  );
};

export const getListMyCommunitiesQueryKey = (
  params?: ListMyCommunitiesParams,
) => {
  return [
    `https://membership.uibfs.or.ug/uib-api/membership/communities/my`,
    ...(params ? [params] : []),
  ] as const;
};

export const getListMyCommunitiesQueryOptions = <
  TData = Awaited<ReturnType<typeof listMyCommunities>>,
  TError = AxiosError<unknown>,
>(
  params?: ListMyCommunitiesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listMyCommunities>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListMyCommunitiesQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listMyCommunities>>
  > = ({ signal }) => listMyCommunities(params, { signal, ...axiosOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listMyCommunities>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ListMyCommunitiesQueryResult = NonNullable<
  Awaited<ReturnType<typeof listMyCommunities>>
>;
export type ListMyCommunitiesQueryError = AxiosError<unknown>;

export function useListMyCommunities<
  TData = Awaited<ReturnType<typeof listMyCommunities>>,
  TError = AxiosError<unknown>,
>(
  params: undefined | ListMyCommunitiesParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listMyCommunities>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listMyCommunities>>,
          TError,
          Awaited<ReturnType<typeof listMyCommunities>>
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useListMyCommunities<
  TData = Awaited<ReturnType<typeof listMyCommunities>>,
  TError = AxiosError<unknown>,
>(
  params?: ListMyCommunitiesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listMyCommunities>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listMyCommunities>>,
          TError,
          Awaited<ReturnType<typeof listMyCommunities>>
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListMyCommunities<
  TData = Awaited<ReturnType<typeof listMyCommunities>>,
  TError = AxiosError<unknown>,
>(
  params?: ListMyCommunitiesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listMyCommunities>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List communities that I belong to
 */

export function useListMyCommunities<
  TData = Awaited<ReturnType<typeof listMyCommunities>>,
  TError = AxiosError<unknown>,
>(
  params?: ListMyCommunitiesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listMyCommunities>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getListMyCommunitiesQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Returns a paginated directory of communities; an optional search term filters names or codes.
 * @summary List all communities/chapters
 */
export const listCommunities = (
  params?: ListCommunitiesParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<PageCommunityDTO>> => {
  return axios.default.get(
    `https://membership.uibfs.or.ug/uib-api/membership/communities/all`,
    {
      ...options,
      params: { ...params, ...options?.params },
    },
  );
};

export const getListCommunitiesQueryKey = (params?: ListCommunitiesParams) => {
  return [
    `https://membership.uibfs.or.ug/uib-api/membership/communities/all`,
    ...(params ? [params] : []),
  ] as const;
};

export const getListCommunitiesQueryOptions = <
  TData = Awaited<ReturnType<typeof listCommunities>>,
  TError = AxiosError<unknown>,
>(
  params?: ListCommunitiesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listCommunities>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListCommunitiesQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listCommunities>>> = ({
    signal,
  }) => listCommunities(params, { signal, ...axiosOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listCommunities>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ListCommunitiesQueryResult = NonNullable<
  Awaited<ReturnType<typeof listCommunities>>
>;
export type ListCommunitiesQueryError = AxiosError<unknown>;

export function useListCommunities<
  TData = Awaited<ReturnType<typeof listCommunities>>,
  TError = AxiosError<unknown>,
>(
  params: undefined | ListCommunitiesParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listCommunities>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listCommunities>>,
          TError,
          Awaited<ReturnType<typeof listCommunities>>
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useListCommunities<
  TData = Awaited<ReturnType<typeof listCommunities>>,
  TError = AxiosError<unknown>,
>(
  params?: ListCommunitiesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listCommunities>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listCommunities>>,
          TError,
          Awaited<ReturnType<typeof listCommunities>>
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListCommunities<
  TData = Awaited<ReturnType<typeof listCommunities>>,
  TError = AxiosError<unknown>,
>(
  params?: ListCommunitiesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listCommunities>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List all communities/chapters
 */

export function useListCommunities<
  TData = Awaited<ReturnType<typeof listCommunities>>,
  TError = AxiosError<unknown>,
>(
  params?: ListCommunitiesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listCommunities>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getListCommunitiesQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Returns all categories with key details, including their configured requirements.
 * @summary List membership categories
 */
export const getAllCategories = (
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<MembershipCategoryResponse[]>> => {
  return axios.default.get(
    `https://membership.uibfs.or.ug/uib-api/membership/categories`,
    options,
  );
};

export const getGetAllCategoriesQueryKey = () => {
  return [
    `https://membership.uibfs.or.ug/uib-api/membership/categories`,
  ] as const;
};

export const getGetAllCategoriesQueryOptions = <
  TData = Awaited<ReturnType<typeof getAllCategories>>,
  TError = AxiosError<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getAllCategories>>, TError, TData>
  >;
  axios?: AxiosRequestConfig;
}) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetAllCategoriesQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getAllCategories>>
  > = ({ signal }) => getAllCategories({ signal, ...axiosOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getAllCategories>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetAllCategoriesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAllCategories>>
>;
export type GetAllCategoriesQueryError = AxiosError<unknown>;

export function useGetAllCategories<
  TData = Awaited<ReturnType<typeof getAllCategories>>,
  TError = AxiosError<unknown>,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAllCategories>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllCategories>>,
          TError,
          Awaited<ReturnType<typeof getAllCategories>>
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetAllCategories<
  TData = Awaited<ReturnType<typeof getAllCategories>>,
  TError = AxiosError<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAllCategories>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllCategories>>,
          TError,
          Awaited<ReturnType<typeof getAllCategories>>
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetAllCategories<
  TData = Awaited<ReturnType<typeof getAllCategories>>,
  TError = AxiosError<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAllCategories>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List membership categories
 */

export function useGetAllCategories<
  TData = Awaited<ReturnType<typeof getAllCategories>>,
  TError = AxiosError<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAllCategories>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetAllCategoriesQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Returns all configured membership benefits.
 * @summary List membership benefits
 */
export const getAllMembershipBenefits = (
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<MembershipBenefitResponseDTO[]>> => {
  return axios.default.get(
    `https://membership.uibfs.or.ug/uib-api/membership/benefits/all`,
    options,
  );
};

export const getGetAllMembershipBenefitsQueryKey = () => {
  return [
    `https://membership.uibfs.or.ug/uib-api/membership/benefits/all`,
  ] as const;
};

export const getGetAllMembershipBenefitsQueryOptions = <
  TData = Awaited<ReturnType<typeof getAllMembershipBenefits>>,
  TError = AxiosError<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getAllMembershipBenefits>>,
      TError,
      TData
    >
  >;
  axios?: AxiosRequestConfig;
}) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetAllMembershipBenefitsQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getAllMembershipBenefits>>
  > = ({ signal }) => getAllMembershipBenefits({ signal, ...axiosOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getAllMembershipBenefits>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetAllMembershipBenefitsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAllMembershipBenefits>>
>;
export type GetAllMembershipBenefitsQueryError = AxiosError<unknown>;

export function useGetAllMembershipBenefits<
  TData = Awaited<ReturnType<typeof getAllMembershipBenefits>>,
  TError = AxiosError<unknown>,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAllMembershipBenefits>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllMembershipBenefits>>,
          TError,
          Awaited<ReturnType<typeof getAllMembershipBenefits>>
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetAllMembershipBenefits<
  TData = Awaited<ReturnType<typeof getAllMembershipBenefits>>,
  TError = AxiosError<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAllMembershipBenefits>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllMembershipBenefits>>,
          TError,
          Awaited<ReturnType<typeof getAllMembershipBenefits>>
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetAllMembershipBenefits<
  TData = Awaited<ReturnType<typeof getAllMembershipBenefits>>,
  TError = AxiosError<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAllMembershipBenefits>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List membership benefits
 */

export function useGetAllMembershipBenefits<
  TData = Awaited<ReturnType<typeof getAllMembershipBenefits>>,
  TError = AxiosError<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAllMembershipBenefits>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetAllMembershipBenefitsQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Returns a paginated list of applications.
 * @summary List applications
 */
export const getApplications = (
  params?: GetApplicationsParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<RestPageImpl>> => {
  return axios.default.get(
    `https://membership.uibfs.or.ug/uib-api/membership/application`,
    {
      ...options,
      params: { ...params, ...options?.params },
    },
  );
};

export const getGetApplicationsQueryKey = (params?: GetApplicationsParams) => {
  return [
    `https://membership.uibfs.or.ug/uib-api/membership/application`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetApplicationsQueryOptions = <
  TData = Awaited<ReturnType<typeof getApplications>>,
  TError = AxiosError<ProblemDetail | ProblemDetail>,
>(
  params?: GetApplicationsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApplications>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetApplicationsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getApplications>>> = ({
    signal,
  }) => getApplications(params, { signal, ...axiosOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApplications>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetApplicationsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApplications>>
>;
export type GetApplicationsQueryError = AxiosError<
  ProblemDetail | ProblemDetail
>;

export function useGetApplications<
  TData = Awaited<ReturnType<typeof getApplications>>,
  TError = AxiosError<ProblemDetail | ProblemDetail>,
>(
  params: undefined | GetApplicationsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApplications>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApplications>>,
          TError,
          Awaited<ReturnType<typeof getApplications>>
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetApplications<
  TData = Awaited<ReturnType<typeof getApplications>>,
  TError = AxiosError<ProblemDetail | ProblemDetail>,
>(
  params?: GetApplicationsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApplications>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApplications>>,
          TError,
          Awaited<ReturnType<typeof getApplications>>
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetApplications<
  TData = Awaited<ReturnType<typeof getApplications>>,
  TError = AxiosError<ProblemDetail | ProblemDetail>,
>(
  params?: GetApplicationsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApplications>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List applications
 */

export function useGetApplications<
  TData = Awaited<ReturnType<typeof getApplications>>,
  TError = AxiosError<ProblemDetail | ProblemDetail>,
>(
  params?: GetApplicationsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApplications>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetApplicationsQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getRenewalRequests = (
  params?: GetRenewalRequestsParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<PageApplicationResponseDTO>> => {
  return axios.default.get(
    `https://membership.uibfs.or.ug/uib-api/membership/application/renewals/requests`,
    {
      ...options,
      params: { ...params, ...options?.params },
    },
  );
};

export const getGetRenewalRequestsQueryKey = (
  params?: GetRenewalRequestsParams,
) => {
  return [
    `https://membership.uibfs.or.ug/uib-api/membership/application/renewals/requests`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetRenewalRequestsQueryOptions = <
  TData = Awaited<ReturnType<typeof getRenewalRequests>>,
  TError = AxiosError<unknown>,
>(
  params?: GetRenewalRequestsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getRenewalRequests>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetRenewalRequestsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getRenewalRequests>>
  > = ({ signal }) => getRenewalRequests(params, { signal, ...axiosOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getRenewalRequests>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetRenewalRequestsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getRenewalRequests>>
>;
export type GetRenewalRequestsQueryError = AxiosError<unknown>;

export function useGetRenewalRequests<
  TData = Awaited<ReturnType<typeof getRenewalRequests>>,
  TError = AxiosError<unknown>,
>(
  params: undefined | GetRenewalRequestsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getRenewalRequests>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRenewalRequests>>,
          TError,
          Awaited<ReturnType<typeof getRenewalRequests>>
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetRenewalRequests<
  TData = Awaited<ReturnType<typeof getRenewalRequests>>,
  TError = AxiosError<unknown>,
>(
  params?: GetRenewalRequestsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getRenewalRequests>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRenewalRequests>>,
          TError,
          Awaited<ReturnType<typeof getRenewalRequests>>
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetRenewalRequests<
  TData = Awaited<ReturnType<typeof getRenewalRequests>>,
  TError = AxiosError<unknown>,
>(
  params?: GetRenewalRequestsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getRenewalRequests>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetRenewalRequests<
  TData = Awaited<ReturnType<typeof getRenewalRequests>>,
  TError = AxiosError<unknown>,
>(
  params?: GetRenewalRequestsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getRenewalRequests>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetRenewalRequestsQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Returns applications submitted by the authenticated user.
 * @summary List current user's applications
 */
export const getMyApplications = (
  params?: GetMyApplicationsParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<RestPageImpl>> => {
  return axios.default.get(
    `https://membership.uibfs.or.ug/uib-api/membership/application/my-applications`,
    {
      ...options,
      params: { ...params, ...options?.params },
    },
  );
};

export const getGetMyApplicationsQueryKey = (
  params?: GetMyApplicationsParams,
) => {
  return [
    `https://membership.uibfs.or.ug/uib-api/membership/application/my-applications`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetMyApplicationsQueryOptions = <
  TData = Awaited<ReturnType<typeof getMyApplications>>,
  TError = AxiosError<ProblemDetail | ProblemDetail>,
>(
  params?: GetMyApplicationsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMyApplications>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetMyApplicationsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getMyApplications>>
  > = ({ signal }) => getMyApplications(params, { signal, ...axiosOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getMyApplications>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetMyApplicationsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMyApplications>>
>;
export type GetMyApplicationsQueryError = AxiosError<
  ProblemDetail | ProblemDetail
>;

export function useGetMyApplications<
  TData = Awaited<ReturnType<typeof getMyApplications>>,
  TError = AxiosError<ProblemDetail | ProblemDetail>,
>(
  params: undefined | GetMyApplicationsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMyApplications>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMyApplications>>,
          TError,
          Awaited<ReturnType<typeof getMyApplications>>
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetMyApplications<
  TData = Awaited<ReturnType<typeof getMyApplications>>,
  TError = AxiosError<ProblemDetail | ProblemDetail>,
>(
  params?: GetMyApplicationsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMyApplications>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMyApplications>>,
          TError,
          Awaited<ReturnType<typeof getMyApplications>>
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetMyApplications<
  TData = Awaited<ReturnType<typeof getMyApplications>>,
  TError = AxiosError<ProblemDetail | ProblemDetail>,
>(
  params?: GetMyApplicationsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMyApplications>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List current user's applications
 */

export function useGetMyApplications<
  TData = Awaited<ReturnType<typeof getMyApplications>>,
  TError = AxiosError<ProblemDetail | ProblemDetail>,
>(
  params?: GetMyApplicationsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMyApplications>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetMyApplicationsQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Returns applications filtered by status.
 * @summary List applications by status
 */
export const getApplicationsByStatus = (
  status: "PENDING" | "APPROVED" | "REJECTED" | "RENEWED",
  params?: GetApplicationsByStatusParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<RestPageImpl>> => {
  return axios.default.get(
    `https://membership.uibfs.or.ug/uib-api/membership/application/by-status/${status}`,
    {
      ...options,
      params: { ...params, ...options?.params },
    },
  );
};

export const getGetApplicationsByStatusQueryKey = (
  status?: "PENDING" | "APPROVED" | "REJECTED" | "RENEWED",
  params?: GetApplicationsByStatusParams,
) => {
  return [
    `https://membership.uibfs.or.ug/uib-api/membership/application/by-status/${status}`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetApplicationsByStatusQueryOptions = <
  TData = Awaited<ReturnType<typeof getApplicationsByStatus>>,
  TError = AxiosError<ProblemDetail | ProblemDetail>,
>(
  status: "PENDING" | "APPROVED" | "REJECTED" | "RENEWED",
  params?: GetApplicationsByStatusParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApplicationsByStatus>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetApplicationsByStatusQueryKey(status, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApplicationsByStatus>>
  > = ({ signal }) =>
    getApplicationsByStatus(status, params, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!status,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getApplicationsByStatus>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetApplicationsByStatusQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApplicationsByStatus>>
>;
export type GetApplicationsByStatusQueryError = AxiosError<
  ProblemDetail | ProblemDetail
>;

export function useGetApplicationsByStatus<
  TData = Awaited<ReturnType<typeof getApplicationsByStatus>>,
  TError = AxiosError<ProblemDetail | ProblemDetail>,
>(
  status: "PENDING" | "APPROVED" | "REJECTED" | "RENEWED",
  params: undefined | GetApplicationsByStatusParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApplicationsByStatus>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApplicationsByStatus>>,
          TError,
          Awaited<ReturnType<typeof getApplicationsByStatus>>
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetApplicationsByStatus<
  TData = Awaited<ReturnType<typeof getApplicationsByStatus>>,
  TError = AxiosError<ProblemDetail | ProblemDetail>,
>(
  status: "PENDING" | "APPROVED" | "REJECTED" | "RENEWED",
  params?: GetApplicationsByStatusParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApplicationsByStatus>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApplicationsByStatus>>,
          TError,
          Awaited<ReturnType<typeof getApplicationsByStatus>>
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetApplicationsByStatus<
  TData = Awaited<ReturnType<typeof getApplicationsByStatus>>,
  TError = AxiosError<ProblemDetail | ProblemDetail>,
>(
  status: "PENDING" | "APPROVED" | "REJECTED" | "RENEWED",
  params?: GetApplicationsByStatusParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApplicationsByStatus>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List applications by status
 */

export function useGetApplicationsByStatus<
  TData = Awaited<ReturnType<typeof getApplicationsByStatus>>,
  TError = AxiosError<ProblemDetail | ProblemDetail>,
>(
  status: "PENDING" | "APPROVED" | "REJECTED" | "RENEWED",
  params?: GetApplicationsByStatusParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApplicationsByStatus>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetApplicationsByStatusQueryOptions(
    status,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Paginated list of members celebrating birthdays within a month/day range (year ignored, default: today)
 */
export const listBirthdays = (
  params?: ListBirthdaysParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<PageApplicationResponseDTO>> => {
  return axios.default.get(
    `https://membership.uibfs.or.ug/uib-api/membership/application/birthdays`,
    {
      ...options,
      params: { ...params, ...options?.params },
    },
  );
};

export const getListBirthdaysQueryKey = (params?: ListBirthdaysParams) => {
  return [
    `https://membership.uibfs.or.ug/uib-api/membership/application/birthdays`,
    ...(params ? [params] : []),
  ] as const;
};

export const getListBirthdaysQueryOptions = <
  TData = Awaited<ReturnType<typeof listBirthdays>>,
  TError = AxiosError<unknown>,
>(
  params?: ListBirthdaysParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listBirthdays>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListBirthdaysQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listBirthdays>>> = ({
    signal,
  }) => listBirthdays(params, { signal, ...axiosOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listBirthdays>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ListBirthdaysQueryResult = NonNullable<
  Awaited<ReturnType<typeof listBirthdays>>
>;
export type ListBirthdaysQueryError = AxiosError<unknown>;

export function useListBirthdays<
  TData = Awaited<ReturnType<typeof listBirthdays>>,
  TError = AxiosError<unknown>,
>(
  params: undefined | ListBirthdaysParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listBirthdays>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listBirthdays>>,
          TError,
          Awaited<ReturnType<typeof listBirthdays>>
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useListBirthdays<
  TData = Awaited<ReturnType<typeof listBirthdays>>,
  TError = AxiosError<unknown>,
>(
  params?: ListBirthdaysParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listBirthdays>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listBirthdays>>,
          TError,
          Awaited<ReturnType<typeof listBirthdays>>
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListBirthdays<
  TData = Awaited<ReturnType<typeof listBirthdays>>,
  TError = AxiosError<unknown>,
>(
  params?: ListBirthdaysParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listBirthdays>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Paginated list of members celebrating birthdays within a month/day range (year ignored, default: today)
 */

export function useListBirthdays<
  TData = Awaited<ReturnType<typeof listBirthdays>>,
  TError = AxiosError<unknown>,
>(
  params?: ListBirthdaysParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listBirthdays>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getListBirthdaysQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary List approved apps, including expired
 */
export const getApprovedApplications = (
  params?: GetApprovedApplicationsParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<ApiResponse>> => {
  return axios.default.get(
    `https://membership.uibfs.or.ug/uib-api/membership/application/approved`,
    {
      ...options,
      params: { ...params, ...options?.params },
    },
  );
};

export const getGetApprovedApplicationsQueryKey = (
  params?: GetApprovedApplicationsParams,
) => {
  return [
    `https://membership.uibfs.or.ug/uib-api/membership/application/approved`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetApprovedApplicationsQueryOptions = <
  TData = Awaited<ReturnType<typeof getApprovedApplications>>,
  TError = AxiosError<unknown>,
>(
  params?: GetApprovedApplicationsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApprovedApplications>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetApprovedApplicationsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApprovedApplications>>
  > = ({ signal }) =>
    getApprovedApplications(params, { signal, ...axiosOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApprovedApplications>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetApprovedApplicationsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApprovedApplications>>
>;
export type GetApprovedApplicationsQueryError = AxiosError<unknown>;

export function useGetApprovedApplications<
  TData = Awaited<ReturnType<typeof getApprovedApplications>>,
  TError = AxiosError<unknown>,
>(
  params: undefined | GetApprovedApplicationsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApprovedApplications>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApprovedApplications>>,
          TError,
          Awaited<ReturnType<typeof getApprovedApplications>>
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetApprovedApplications<
  TData = Awaited<ReturnType<typeof getApprovedApplications>>,
  TError = AxiosError<unknown>,
>(
  params?: GetApprovedApplicationsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApprovedApplications>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApprovedApplications>>,
          TError,
          Awaited<ReturnType<typeof getApprovedApplications>>
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetApprovedApplications<
  TData = Awaited<ReturnType<typeof getApprovedApplications>>,
  TError = AxiosError<unknown>,
>(
  params?: GetApprovedApplicationsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApprovedApplications>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List approved apps, including expired
 */

export function useGetApprovedApplications<
  TData = Awaited<ReturnType<typeof getApprovedApplications>>,
  TError = AxiosError<unknown>,
>(
  params?: GetApprovedApplicationsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApprovedApplications>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetApprovedApplicationsQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Returns approved applications including subscription dates, amount, period and time remaining.
 * @summary List approved applications with subscription details
 */
export const getApprovedApplicationsWithDetails = (
  params?: GetApprovedApplicationsWithDetailsParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<RestPageImpl>> => {
  return axios.default.get(
    `https://membership.uibfs.or.ug/uib-api/membership/application/approved/details`,
    {
      ...options,
      params: { ...params, ...options?.params },
    },
  );
};

export const getGetApprovedApplicationsWithDetailsQueryKey = (
  params?: GetApprovedApplicationsWithDetailsParams,
) => {
  return [
    `https://membership.uibfs.or.ug/uib-api/membership/application/approved/details`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetApprovedApplicationsWithDetailsQueryOptions = <
  TData = Awaited<ReturnType<typeof getApprovedApplicationsWithDetails>>,
  TError = AxiosError<ProblemDetail | ProblemDetail>,
>(
  params?: GetApprovedApplicationsWithDetailsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApprovedApplicationsWithDetails>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetApprovedApplicationsWithDetailsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApprovedApplicationsWithDetails>>
  > = ({ signal }) =>
    getApprovedApplicationsWithDetails(params, { signal, ...axiosOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApprovedApplicationsWithDetails>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetApprovedApplicationsWithDetailsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApprovedApplicationsWithDetails>>
>;
export type GetApprovedApplicationsWithDetailsQueryError = AxiosError<
  ProblemDetail | ProblemDetail
>;

export function useGetApprovedApplicationsWithDetails<
  TData = Awaited<ReturnType<typeof getApprovedApplicationsWithDetails>>,
  TError = AxiosError<ProblemDetail | ProblemDetail>,
>(
  params: undefined | GetApprovedApplicationsWithDetailsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApprovedApplicationsWithDetails>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApprovedApplicationsWithDetails>>,
          TError,
          Awaited<ReturnType<typeof getApprovedApplicationsWithDetails>>
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetApprovedApplicationsWithDetails<
  TData = Awaited<ReturnType<typeof getApprovedApplicationsWithDetails>>,
  TError = AxiosError<ProblemDetail | ProblemDetail>,
>(
  params?: GetApprovedApplicationsWithDetailsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApprovedApplicationsWithDetails>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApprovedApplicationsWithDetails>>,
          TError,
          Awaited<ReturnType<typeof getApprovedApplicationsWithDetails>>
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetApprovedApplicationsWithDetails<
  TData = Awaited<ReturnType<typeof getApprovedApplicationsWithDetails>>,
  TError = AxiosError<ProblemDetail | ProblemDetail>,
>(
  params?: GetApprovedApplicationsWithDetailsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApprovedApplicationsWithDetails>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List approved applications with subscription details
 */

export function useGetApprovedApplicationsWithDetails<
  TData = Awaited<ReturnType<typeof getApprovedApplicationsWithDetails>>,
  TError = AxiosError<ProblemDetail | ProblemDetail>,
>(
  params?: GetApprovedApplicationsWithDetailsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApprovedApplicationsWithDetails>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetApprovedApplicationsWithDetailsQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Returns all approved applications that have not expired.
 * @summary Get active approved applications
 */
export const getActiveApprovedApplications = (
  params?: GetActiveApprovedApplicationsParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<RestPageImpl>> => {
  return axios.default.get(
    `https://membership.uibfs.or.ug/uib-api/membership/application/approved/active`,
    {
      ...options,
      params: { ...params, ...options?.params },
    },
  );
};

export const getGetActiveApprovedApplicationsQueryKey = (
  params?: GetActiveApprovedApplicationsParams,
) => {
  return [
    `https://membership.uibfs.or.ug/uib-api/membership/application/approved/active`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetActiveApprovedApplicationsQueryOptions = <
  TData = Awaited<ReturnType<typeof getActiveApprovedApplications>>,
  TError = AxiosError<ProblemDetail | ProblemDetail>,
>(
  params?: GetActiveApprovedApplicationsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getActiveApprovedApplications>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetActiveApprovedApplicationsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getActiveApprovedApplications>>
  > = ({ signal }) =>
    getActiveApprovedApplications(params, { signal, ...axiosOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getActiveApprovedApplications>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetActiveApprovedApplicationsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getActiveApprovedApplications>>
>;
export type GetActiveApprovedApplicationsQueryError = AxiosError<
  ProblemDetail | ProblemDetail
>;

export function useGetActiveApprovedApplications<
  TData = Awaited<ReturnType<typeof getActiveApprovedApplications>>,
  TError = AxiosError<ProblemDetail | ProblemDetail>,
>(
  params: undefined | GetActiveApprovedApplicationsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getActiveApprovedApplications>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getActiveApprovedApplications>>,
          TError,
          Awaited<ReturnType<typeof getActiveApprovedApplications>>
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetActiveApprovedApplications<
  TData = Awaited<ReturnType<typeof getActiveApprovedApplications>>,
  TError = AxiosError<ProblemDetail | ProblemDetail>,
>(
  params?: GetActiveApprovedApplicationsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getActiveApprovedApplications>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getActiveApprovedApplications>>,
          TError,
          Awaited<ReturnType<typeof getActiveApprovedApplications>>
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetActiveApprovedApplications<
  TData = Awaited<ReturnType<typeof getActiveApprovedApplications>>,
  TError = AxiosError<ProblemDetail | ProblemDetail>,
>(
  params?: GetActiveApprovedApplicationsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getActiveApprovedApplications>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get active approved applications
 */

export function useGetActiveApprovedApplications<
  TData = Awaited<ReturnType<typeof getActiveApprovedApplications>>,
  TError = AxiosError<ProblemDetail | ProblemDetail>,
>(
  params?: GetActiveApprovedApplicationsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getActiveApprovedApplications>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetActiveApprovedApplicationsQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getPendingRenewalApplications = (
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<ApiResponse>> => {
  return axios.default.get(
    `https://membership.uibfs.or.ug/uib-api/membership/application/applications/renewals/pending`,
    options,
  );
};

export const getGetPendingRenewalApplicationsQueryKey = () => {
  return [
    `https://membership.uibfs.or.ug/uib-api/membership/application/applications/renewals/pending`,
  ] as const;
};

export const getGetPendingRenewalApplicationsQueryOptions = <
  TData = Awaited<ReturnType<typeof getPendingRenewalApplications>>,
  TError = AxiosError<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getPendingRenewalApplications>>,
      TError,
      TData
    >
  >;
  axios?: AxiosRequestConfig;
}) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetPendingRenewalApplicationsQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getPendingRenewalApplications>>
  > = ({ signal }) =>
    getPendingRenewalApplications({ signal, ...axiosOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getPendingRenewalApplications>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetPendingRenewalApplicationsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getPendingRenewalApplications>>
>;
export type GetPendingRenewalApplicationsQueryError = AxiosError<unknown>;

export function useGetPendingRenewalApplications<
  TData = Awaited<ReturnType<typeof getPendingRenewalApplications>>,
  TError = AxiosError<unknown>,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPendingRenewalApplications>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPendingRenewalApplications>>,
          TError,
          Awaited<ReturnType<typeof getPendingRenewalApplications>>
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetPendingRenewalApplications<
  TData = Awaited<ReturnType<typeof getPendingRenewalApplications>>,
  TError = AxiosError<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPendingRenewalApplications>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPendingRenewalApplications>>,
          TError,
          Awaited<ReturnType<typeof getPendingRenewalApplications>>
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetPendingRenewalApplications<
  TData = Awaited<ReturnType<typeof getPendingRenewalApplications>>,
  TError = AxiosError<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPendingRenewalApplications>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetPendingRenewalApplications<
  TData = Awaited<ReturnType<typeof getPendingRenewalApplications>>,
  TError = AxiosError<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPendingRenewalApplications>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetPendingRenewalApplicationsQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Retrieve most accessed resources across all members within the specified time period
 * @summary Get top accessed resources
 */
export const topResources = (
  params?: TopResourcesParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<TopResources200Item[]>> => {
  return axios.default.get(
    `https://membership.uibfs.or.ug/uib-api/membership/analytics/resources/top`,
    {
      ...options,
      params: { ...params, ...options?.params },
    },
  );
};

export const getTopResourcesQueryKey = (params?: TopResourcesParams) => {
  return [
    `https://membership.uibfs.or.ug/uib-api/membership/analytics/resources/top`,
    ...(params ? [params] : []),
  ] as const;
};

export const getTopResourcesQueryOptions = <
  TData = Awaited<ReturnType<typeof topResources>>,
  TError = AxiosError<unknown>,
>(
  params?: TopResourcesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof topResources>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getTopResourcesQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof topResources>>> = ({
    signal,
  }) => topResources(params, { signal, ...axiosOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof topResources>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type TopResourcesQueryResult = NonNullable<
  Awaited<ReturnType<typeof topResources>>
>;
export type TopResourcesQueryError = AxiosError<unknown>;

export function useTopResources<
  TData = Awaited<ReturnType<typeof topResources>>,
  TError = AxiosError<unknown>,
>(
  params: undefined | TopResourcesParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof topResources>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof topResources>>,
          TError,
          Awaited<ReturnType<typeof topResources>>
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useTopResources<
  TData = Awaited<ReturnType<typeof topResources>>,
  TError = AxiosError<unknown>,
>(
  params?: TopResourcesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof topResources>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof topResources>>,
          TError,
          Awaited<ReturnType<typeof topResources>>
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useTopResources<
  TData = Awaited<ReturnType<typeof topResources>>,
  TError = AxiosError<unknown>,
>(
  params?: TopResourcesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof topResources>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get top accessed resources
 */

export function useTopResources<
  TData = Awaited<ReturnType<typeof topResources>>,
  TError = AxiosError<unknown>,
>(
  params?: TopResourcesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof topResources>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getTopResourcesQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Retrieve paginated list of all activities for a specific member
 * @summary Get member activities
 */
export const byMember = (
  memberId: number,
  params?: ByMemberParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<PageResourceAccessEvent>> => {
  return axios.default.get(
    `https://membership.uibfs.or.ug/uib-api/membership/analytics/resources/member/${memberId}`,
    {
      ...options,
      params: { ...params, ...options?.params },
    },
  );
};

export const getByMemberQueryKey = (
  memberId?: number,
  params?: ByMemberParams,
) => {
  return [
    `https://membership.uibfs.or.ug/uib-api/membership/analytics/resources/member/${memberId}`,
    ...(params ? [params] : []),
  ] as const;
};

export const getByMemberQueryOptions = <
  TData = Awaited<ReturnType<typeof byMember>>,
  TError = AxiosError<PageResourceAccessEvent | PageResourceAccessEvent>,
>(
  memberId: number,
  params?: ByMemberParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof byMember>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getByMemberQueryKey(memberId, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof byMember>>> = ({
    signal,
  }) => byMember(memberId, params, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!memberId,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof byMember>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData>;
  };
};

export type ByMemberQueryResult = NonNullable<
  Awaited<ReturnType<typeof byMember>>
>;
export type ByMemberQueryError = AxiosError<
  PageResourceAccessEvent | PageResourceAccessEvent
>;

export function useByMember<
  TData = Awaited<ReturnType<typeof byMember>>,
  TError = AxiosError<PageResourceAccessEvent | PageResourceAccessEvent>,
>(
  memberId: number,
  params: undefined | ByMemberParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof byMember>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof byMember>>,
          TError,
          Awaited<ReturnType<typeof byMember>>
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useByMember<
  TData = Awaited<ReturnType<typeof byMember>>,
  TError = AxiosError<PageResourceAccessEvent | PageResourceAccessEvent>,
>(
  memberId: number,
  params?: ByMemberParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof byMember>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof byMember>>,
          TError,
          Awaited<ReturnType<typeof byMember>>
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useByMember<
  TData = Awaited<ReturnType<typeof byMember>>,
  TError = AxiosError<PageResourceAccessEvent | PageResourceAccessEvent>,
>(
  memberId: number,
  params?: ByMemberParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof byMember>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get member activities
 */

export function useByMember<
  TData = Awaited<ReturnType<typeof byMember>>,
  TError = AxiosError<PageResourceAccessEvent | PageResourceAccessEvent>,
>(
  memberId: number,
  params?: ByMemberParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof byMember>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getByMemberQueryOptions(memberId, params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Get hourly, daily, and resource type distribution trends for a member
 * @summary Get activity trends
 */
export const getActivityTrends = (
  memberId: number,
  params?: GetActivityTrendsParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<GetActivityTrends200>> => {
  return axios.default.get(
    `https://membership.uibfs.or.ug/uib-api/membership/analytics/resources/member/${memberId}/trends`,
    {
      ...options,
      params: { ...params, ...options?.params },
    },
  );
};

export const getGetActivityTrendsQueryKey = (
  memberId?: number,
  params?: GetActivityTrendsParams,
) => {
  return [
    `https://membership.uibfs.or.ug/uib-api/membership/analytics/resources/member/${memberId}/trends`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetActivityTrendsQueryOptions = <
  TData = Awaited<ReturnType<typeof getActivityTrends>>,
  TError = AxiosError<unknown>,
>(
  memberId: number,
  params?: GetActivityTrendsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getActivityTrends>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetActivityTrendsQueryKey(memberId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getActivityTrends>>
  > = ({ signal }) =>
    getActivityTrends(memberId, params, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!memberId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getActivityTrends>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetActivityTrendsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getActivityTrends>>
>;
export type GetActivityTrendsQueryError = AxiosError<unknown>;

export function useGetActivityTrends<
  TData = Awaited<ReturnType<typeof getActivityTrends>>,
  TError = AxiosError<unknown>,
>(
  memberId: number,
  params: undefined | GetActivityTrendsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getActivityTrends>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getActivityTrends>>,
          TError,
          Awaited<ReturnType<typeof getActivityTrends>>
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetActivityTrends<
  TData = Awaited<ReturnType<typeof getActivityTrends>>,
  TError = AxiosError<unknown>,
>(
  memberId: number,
  params?: GetActivityTrendsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getActivityTrends>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getActivityTrends>>,
          TError,
          Awaited<ReturnType<typeof getActivityTrends>>
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetActivityTrends<
  TData = Awaited<ReturnType<typeof getActivityTrends>>,
  TError = AxiosError<unknown>,
>(
  memberId: number,
  params?: GetActivityTrendsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getActivityTrends>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get activity trends
 */

export function useGetActivityTrends<
  TData = Awaited<ReturnType<typeof getActivityTrends>>,
  TError = AxiosError<unknown>,
>(
  memberId: number,
  params?: GetActivityTrendsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getActivityTrends>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetActivityTrendsQueryOptions(
    memberId,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Get detailed analytics summary including total activities, breakdowns by type/action, top resources, and daily patterns. Date parameters are optional (defaults to last 30 days).
 * @summary Get comprehensive activity summary
 */
export const getMemberSummary = (
  memberId: number,
  params?: GetMemberSummaryParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<ActivitySummaryDTO>> => {
  return axios.default.get(
    `https://membership.uibfs.or.ug/uib-api/membership/analytics/resources/member/${memberId}/summary`,
    {
      ...options,
      params: { ...params, ...options?.params },
    },
  );
};

export const getGetMemberSummaryQueryKey = (
  memberId?: number,
  params?: GetMemberSummaryParams,
) => {
  return [
    `https://membership.uibfs.or.ug/uib-api/membership/analytics/resources/member/${memberId}/summary`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetMemberSummaryQueryOptions = <
  TData = Awaited<ReturnType<typeof getMemberSummary>>,
  TError = AxiosError<ActivitySummaryDTO>,
>(
  memberId: number,
  params?: GetMemberSummaryParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMemberSummary>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetMemberSummaryQueryKey(memberId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getMemberSummary>>
  > = ({ signal }) =>
    getMemberSummary(memberId, params, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!memberId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getMemberSummary>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetMemberSummaryQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMemberSummary>>
>;
export type GetMemberSummaryQueryError = AxiosError<ActivitySummaryDTO>;

export function useGetMemberSummary<
  TData = Awaited<ReturnType<typeof getMemberSummary>>,
  TError = AxiosError<ActivitySummaryDTO>,
>(
  memberId: number,
  params: undefined | GetMemberSummaryParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMemberSummary>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMemberSummary>>,
          TError,
          Awaited<ReturnType<typeof getMemberSummary>>
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetMemberSummary<
  TData = Awaited<ReturnType<typeof getMemberSummary>>,
  TError = AxiosError<ActivitySummaryDTO>,
>(
  memberId: number,
  params?: GetMemberSummaryParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMemberSummary>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMemberSummary>>,
          TError,
          Awaited<ReturnType<typeof getMemberSummary>>
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetMemberSummary<
  TData = Awaited<ReturnType<typeof getMemberSummary>>,
  TError = AxiosError<ActivitySummaryDTO>,
>(
  memberId: number,
  params?: GetMemberSummaryParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMemberSummary>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get comprehensive activity summary
 */

export function useGetMemberSummary<
  TData = Awaited<ReturnType<typeof getMemberSummary>>,
  TError = AxiosError<ActivitySummaryDTO>,
>(
  memberId: number,
  params?: GetMemberSummaryParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMemberSummary>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetMemberSummaryQueryOptions(
    memberId,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Get member's recent activities within the specified number of hours
 * @summary Get recent activities
 */
export const getRecentActivity = (
  memberId: number,
  params?: GetRecentActivityParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<ResourceAccessEvent[]>> => {
  return axios.default.get(
    `https://membership.uibfs.or.ug/uib-api/membership/analytics/resources/member/${memberId}/recent`,
    {
      ...options,
      params: { ...params, ...options?.params },
    },
  );
};

export const getGetRecentActivityQueryKey = (
  memberId?: number,
  params?: GetRecentActivityParams,
) => {
  return [
    `https://membership.uibfs.or.ug/uib-api/membership/analytics/resources/member/${memberId}/recent`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetRecentActivityQueryOptions = <
  TData = Awaited<ReturnType<typeof getRecentActivity>>,
  TError = AxiosError<unknown>,
>(
  memberId: number,
  params?: GetRecentActivityParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getRecentActivity>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetRecentActivityQueryKey(memberId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getRecentActivity>>
  > = ({ signal }) =>
    getRecentActivity(memberId, params, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!memberId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getRecentActivity>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetRecentActivityQueryResult = NonNullable<
  Awaited<ReturnType<typeof getRecentActivity>>
>;
export type GetRecentActivityQueryError = AxiosError<unknown>;

export function useGetRecentActivity<
  TData = Awaited<ReturnType<typeof getRecentActivity>>,
  TError = AxiosError<unknown>,
>(
  memberId: number,
  params: undefined | GetRecentActivityParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getRecentActivity>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRecentActivity>>,
          TError,
          Awaited<ReturnType<typeof getRecentActivity>>
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetRecentActivity<
  TData = Awaited<ReturnType<typeof getRecentActivity>>,
  TError = AxiosError<unknown>,
>(
  memberId: number,
  params?: GetRecentActivityParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getRecentActivity>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRecentActivity>>,
          TError,
          Awaited<ReturnType<typeof getRecentActivity>>
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetRecentActivity<
  TData = Awaited<ReturnType<typeof getRecentActivity>>,
  TError = AxiosError<unknown>,
>(
  memberId: number,
  params?: GetRecentActivityParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getRecentActivity>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get recent activities
 */

export function useGetRecentActivity<
  TData = Awaited<ReturnType<typeof getRecentActivity>>,
  TError = AxiosError<unknown>,
>(
  memberId: number,
  params?: GetRecentActivityParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getRecentActivity>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetRecentActivityQueryOptions(
    memberId,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Calculate member engagement score (0-100) based on frequency, consistency, diversity, and breadth of activities
 * @summary Get engagement score
 */
export const getEngagementScore = (
  memberId: number,
  params?: GetEngagementScoreParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<GetEngagementScore200>> => {
  return axios.default.get(
    `https://membership.uibfs.or.ug/uib-api/membership/analytics/resources/member/${memberId}/engagement`,
    {
      ...options,
      params: { ...params, ...options?.params },
    },
  );
};

export const getGetEngagementScoreQueryKey = (
  memberId?: number,
  params?: GetEngagementScoreParams,
) => {
  return [
    `https://membership.uibfs.or.ug/uib-api/membership/analytics/resources/member/${memberId}/engagement`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetEngagementScoreQueryOptions = <
  TData = Awaited<ReturnType<typeof getEngagementScore>>,
  TError = AxiosError<GetEngagementScore401>,
>(
  memberId: number,
  params?: GetEngagementScoreParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getEngagementScore>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetEngagementScoreQueryKey(memberId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getEngagementScore>>
  > = ({ signal }) =>
    getEngagementScore(memberId, params, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!memberId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getEngagementScore>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetEngagementScoreQueryResult = NonNullable<
  Awaited<ReturnType<typeof getEngagementScore>>
>;
export type GetEngagementScoreQueryError = AxiosError<GetEngagementScore401>;

export function useGetEngagementScore<
  TData = Awaited<ReturnType<typeof getEngagementScore>>,
  TError = AxiosError<GetEngagementScore401>,
>(
  memberId: number,
  params: undefined | GetEngagementScoreParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getEngagementScore>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEngagementScore>>,
          TError,
          Awaited<ReturnType<typeof getEngagementScore>>
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetEngagementScore<
  TData = Awaited<ReturnType<typeof getEngagementScore>>,
  TError = AxiosError<GetEngagementScore401>,
>(
  memberId: number,
  params?: GetEngagementScoreParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getEngagementScore>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEngagementScore>>,
          TError,
          Awaited<ReturnType<typeof getEngagementScore>>
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetEngagementScore<
  TData = Awaited<ReturnType<typeof getEngagementScore>>,
  TError = AxiosError<GetEngagementScore401>,
>(
  memberId: number,
  params?: GetEngagementScoreParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getEngagementScore>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get engagement score
 */

export function useGetEngagementScore<
  TData = Awaited<ReturnType<typeof getEngagementScore>>,
  TError = AxiosError<GetEngagementScore401>,
>(
  memberId: number,
  params?: GetEngagementScoreParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getEngagementScore>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetEngagementScoreQueryOptions(
    memberId,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Get the total number of activities for a specific member
 * @summary Get total activity count
 */
export const getTotalActivityCount = (
  memberId: number,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<GetTotalActivityCount200>> => {
  return axios.default.get(
    `https://membership.uibfs.or.ug/uib-api/membership/analytics/resources/member/${memberId}/count`,
    options,
  );
};

export const getGetTotalActivityCountQueryKey = (memberId?: number) => {
  return [
    `https://membership.uibfs.or.ug/uib-api/membership/analytics/resources/member/${memberId}/count`,
  ] as const;
};

export const getGetTotalActivityCountQueryOptions = <
  TData = Awaited<ReturnType<typeof getTotalActivityCount>>,
  TError = AxiosError<unknown>,
>(
  memberId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTotalActivityCount>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetTotalActivityCountQueryKey(memberId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getTotalActivityCount>>
  > = ({ signal }) =>
    getTotalActivityCount(memberId, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!memberId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getTotalActivityCount>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetTotalActivityCountQueryResult = NonNullable<
  Awaited<ReturnType<typeof getTotalActivityCount>>
>;
export type GetTotalActivityCountQueryError = AxiosError<unknown>;

export function useGetTotalActivityCount<
  TData = Awaited<ReturnType<typeof getTotalActivityCount>>,
  TError = AxiosError<unknown>,
>(
  memberId: number,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTotalActivityCount>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTotalActivityCount>>,
          TError,
          Awaited<ReturnType<typeof getTotalActivityCount>>
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetTotalActivityCount<
  TData = Awaited<ReturnType<typeof getTotalActivityCount>>,
  TError = AxiosError<unknown>,
>(
  memberId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTotalActivityCount>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTotalActivityCount>>,
          TError,
          Awaited<ReturnType<typeof getTotalActivityCount>>
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetTotalActivityCount<
  TData = Awaited<ReturnType<typeof getTotalActivityCount>>,
  TError = AxiosError<unknown>,
>(
  memberId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTotalActivityCount>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get total activity count
 */

export function useGetTotalActivityCount<
  TData = Awaited<ReturnType<typeof getTotalActivityCount>>,
  TError = AxiosError<unknown>,
>(
  memberId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTotalActivityCount>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetTotalActivityCountQueryOptions(memberId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const generateReport = (
  reportId: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<string>> => {
  return axios.default.get(
    `https://membership.uibfs.or.ug/uib-api/api/content/reports/${reportId}`,
    {
      responseType: "text",
      ...options,
    },
  );
};

export const getGenerateReportQueryKey = (reportId?: string) => {
  return [
    `https://membership.uibfs.or.ug/uib-api/api/content/reports/${reportId}`,
  ] as const;
};

export const getGenerateReportQueryOptions = <
  TData = Awaited<ReturnType<typeof generateReport>>,
  TError = AxiosError<unknown>,
>(
  reportId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof generateReport>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGenerateReportQueryKey(reportId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof generateReport>>> = ({
    signal,
  }) => generateReport(reportId, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!reportId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof generateReport>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GenerateReportQueryResult = NonNullable<
  Awaited<ReturnType<typeof generateReport>>
>;
export type GenerateReportQueryError = AxiosError<unknown>;

export function useGenerateReport<
  TData = Awaited<ReturnType<typeof generateReport>>,
  TError = AxiosError<unknown>,
>(
  reportId: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof generateReport>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof generateReport>>,
          TError,
          Awaited<ReturnType<typeof generateReport>>
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGenerateReport<
  TData = Awaited<ReturnType<typeof generateReport>>,
  TError = AxiosError<unknown>,
>(
  reportId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof generateReport>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof generateReport>>,
          TError,
          Awaited<ReturnType<typeof generateReport>>
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGenerateReport<
  TData = Awaited<ReturnType<typeof generateReport>>,
  TError = AxiosError<unknown>,
>(
  reportId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof generateReport>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGenerateReport<
  TData = Awaited<ReturnType<typeof generateReport>>,
  TError = AxiosError<unknown>,
>(
  reportId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof generateReport>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGenerateReportQueryOptions(reportId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const viewPage1 = (
  params: ViewPage1Params,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<string>> => {
  return axios.default.get(
    `https://membership.uibfs.or.ug/uib-api/api/content/pages`,
    {
      responseType: "text",
      ...options,
      params: { ...params, ...options?.params },
    },
  );
};

export const getViewPage1QueryKey = (params?: ViewPage1Params) => {
  return [
    `https://membership.uibfs.or.ug/uib-api/api/content/pages`,
    ...(params ? [params] : []),
  ] as const;
};

export const getViewPage1QueryOptions = <
  TData = Awaited<ReturnType<typeof viewPage1>>,
  TError = AxiosError<unknown>,
>(
  params: ViewPage1Params,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof viewPage1>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getViewPage1QueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof viewPage1>>> = ({
    signal,
  }) => viewPage1(params, { signal, ...axiosOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof viewPage1>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ViewPage1QueryResult = NonNullable<
  Awaited<ReturnType<typeof viewPage1>>
>;
export type ViewPage1QueryError = AxiosError<unknown>;

export function useViewPage1<
  TData = Awaited<ReturnType<typeof viewPage1>>,
  TError = AxiosError<unknown>,
>(
  params: ViewPage1Params,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof viewPage1>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof viewPage1>>,
          TError,
          Awaited<ReturnType<typeof viewPage1>>
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useViewPage1<
  TData = Awaited<ReturnType<typeof viewPage1>>,
  TError = AxiosError<unknown>,
>(
  params: ViewPage1Params,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof viewPage1>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof viewPage1>>,
          TError,
          Awaited<ReturnType<typeof viewPage1>>
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useViewPage1<
  TData = Awaited<ReturnType<typeof viewPage1>>,
  TError = AxiosError<unknown>,
>(
  params: ViewPage1Params,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof viewPage1>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useViewPage1<
  TData = Awaited<ReturnType<typeof viewPage1>>,
  TError = AxiosError<unknown>,
>(
  params: ViewPage1Params,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof viewPage1>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getViewPage1QueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const viewDocument1 = (
  documentId: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<string>> => {
  return axios.default.get(
    `https://membership.uibfs.or.ug/uib-api/api/content/documents/${documentId}`,
    {
      responseType: "text",
      ...options,
    },
  );
};

export const getViewDocument1QueryKey = (documentId?: string) => {
  return [
    `https://membership.uibfs.or.ug/uib-api/api/content/documents/${documentId}`,
  ] as const;
};

export const getViewDocument1QueryOptions = <
  TData = Awaited<ReturnType<typeof viewDocument1>>,
  TError = AxiosError<unknown>,
>(
  documentId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof viewDocument1>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getViewDocument1QueryKey(documentId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof viewDocument1>>> = ({
    signal,
  }) => viewDocument1(documentId, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!documentId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof viewDocument1>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ViewDocument1QueryResult = NonNullable<
  Awaited<ReturnType<typeof viewDocument1>>
>;
export type ViewDocument1QueryError = AxiosError<unknown>;

export function useViewDocument1<
  TData = Awaited<ReturnType<typeof viewDocument1>>,
  TError = AxiosError<unknown>,
>(
  documentId: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof viewDocument1>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof viewDocument1>>,
          TError,
          Awaited<ReturnType<typeof viewDocument1>>
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useViewDocument1<
  TData = Awaited<ReturnType<typeof viewDocument1>>,
  TError = AxiosError<unknown>,
>(
  documentId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof viewDocument1>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof viewDocument1>>,
          TError,
          Awaited<ReturnType<typeof viewDocument1>>
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useViewDocument1<
  TData = Awaited<ReturnType<typeof viewDocument1>>,
  TError = AxiosError<unknown>,
>(
  documentId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof viewDocument1>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useViewDocument1<
  TData = Awaited<ReturnType<typeof viewDocument1>>,
  TError = AxiosError<unknown>,
>(
  documentId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof viewDocument1>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getViewDocument1QueryOptions(documentId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Removes a programme from the catalogue.
 * @summary Delete programme
 */
export const deleteCPDProgram = (
  id: number,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<null>> => {
  return axios.default.delete(
    `https://membership.uibfs.or.ug/uib-api/membership/delete-cpd-program/${id}`,
    options,
  );
};

export const getDeleteCPDProgramMutationOptions = <
  TError = AxiosError<null>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteCPDProgram>>,
    TError,
    { id: number },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteCPDProgram>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ["deleteCPDProgram"];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteCPDProgram>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return deleteCPDProgram(id, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteCPDProgramMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteCPDProgram>>
>;

export type DeleteCPDProgramMutationError = AxiosError<null>;

/**
 * @summary Delete programme
 */
export const useDeleteCPDProgram = <
  TError = AxiosError<null>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteCPDProgram>>,
      TError,
      { id: number },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof deleteCPDProgram>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationOptions = getDeleteCPDProgramMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Cancel a user's event registration
 * @summary Cancel registration
 */
export const cancelRegistration = (
  participantId: number,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<CancelRegistration200>> => {
  return axios.default.delete(
    `https://membership.uibfs.or.ug/uib-api/membership/cpd-events/registrations/${participantId}`,
    options,
  );
};

export const getCancelRegistrationMutationOptions = <
  TError = AxiosError<
    | CancelRegistration400
    | CancelRegistration403
    | CancelRegistration404
    | CancelRegistration500
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof cancelRegistration>>,
    TError,
    { participantId: number },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof cancelRegistration>>,
  TError,
  { participantId: number },
  TContext
> => {
  const mutationKey = ["cancelRegistration"];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof cancelRegistration>>,
    { participantId: number }
  > = (props) => {
    const { participantId } = props ?? {};

    return cancelRegistration(participantId, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CancelRegistrationMutationResult = NonNullable<
  Awaited<ReturnType<typeof cancelRegistration>>
>;

export type CancelRegistrationMutationError = AxiosError<
  | CancelRegistration400
  | CancelRegistration403
  | CancelRegistration404
  | CancelRegistration500
>;

/**
 * @summary Cancel registration
 */
export const useCancelRegistration = <
  TError = AxiosError<
    | CancelRegistration400
    | CancelRegistration403
    | CancelRegistration404
    | CancelRegistration500
  >,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof cancelRegistration>>,
      TError,
      { participantId: number },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof cancelRegistration>>,
  TError,
  { participantId: number },
  TContext
> => {
  const mutationOptions = getCancelRegistrationMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
